/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, takeLatest, put } from "redux-saga/effects";
import { newRequest } from "../../../api/token";


import {
  GET_SEARCH_LOC,
  GET_CURRENCY_LIST,
  GET_NATIONALITY_LIST,
  GET_AGENTS_LIST, // TW
  GET_AGENTS_USERS_LIST, // TW
  GET_CURRENCIES_BY_AGENTID, // TW
  GET_CITY_LIST,
  GET_HOTEL_SEARCH,
  GET_HOTELS_LIST,
  GET_SEARCH_ADDRESSES,
  GET_SEARCH_EXTRA_DETAILS,
  GET_HOTEL_LEVEL_FILTER,
  GET_AIRPORTS,
  GET_ACCOMMODATION,
  GET_DESTINATION,
  GET_DESTINATIONTO,
  GET_CALL_CANCELLATION_POLICY,
  GET_BOOKNOW_ID,
  GET_RECHECK_PRICE,
  GET_HOTEL_CHECKOUT_DETAILS,
  GET_ALL_CURRENT_SUPPLIERS,
  GET_AGENT_CREDIT_LIMIT,
  GET_MAIL_TEMPLATE,
  GET_ADD_MAIL_LOG,
  GET_AGENT_BY_ID,
  GET_ADD_AGENTQUOTE,
  GET_ACTIVE_AGENTS_DETAILS,
  GET_ADD_UPDATE_BOOKING_DRAFT,
  GET_BOOKINGDRAFT_BY_TWBID,
  GET_GET_THRESHOLDLIMIT,
  GET_ADD_UPDATE_BOOKING_UPLOAD,
  GET_CURRENCY_CONVERSION_RATES,
  GET_AIRLINES,
  GET_BOOKING_DETAILS_BYBID,
  ADD_PG_TRANSACTION_DETAILS,
  GENERATE_HASH512_DETAILS,
  GENERATE_FEATURED_HOTELS_DETAILS,
  GENERATE_INVOICE_PDF_ACTIONTYPE,
  VALIDATE_PAN_DETAILS,
  UPDATE_VALIDATION_STATUS_DETAILS,
  ABANDON_REASONS_DETAILS,
  GET_ADD_USER_SEARCH_HISTORY,
  GET_GET_USER_SEARCH_HISTORY,
  GET_DMC_LIST,
  GET_DMC_CITIES_LIST,
  GET_DMC_TOURTYPES_LIST,
  GET_DMC_PACKAGES_LIST,
  GET_DMC_PACKAGES_DETAILS_LIST,
  SET_ZOHO_TICKET_CREATION,
  SET_ZOHO_LAYOUT_RULES,
  SET_ZOHO_TICKET_DEPENDENCY_MAPPING,
  BOOKABLE_THRESHOLD_DETAILS,
  BOOKABLE_CL_DETAILS,
  BOOKABLE_WB_DETAILS,
  GET_AGENT_PROFILE_BY_AGENTID,
  CONFIG_VALUE,
  PREVIEW_URL,
  PAYMENT_GATEWAY_TRANSACTIONS,
  AGENT_ALL_WIDGETS_DATA,
  POST_PAYMENT_GATEWAY,
  VOUCHER_VIEW_DETAILS,
  VOUCHER_VIEW_EURAIL_DETAILS,
  BID_FROM_TEMP_ID,
  VOUCHER_VIEW_TRANSFER_DETAILS,
  VOUCHER_VIEW_ACTIVITY_DETAILS,
  UPDATE_PG_INVOICE_NUMBER,
  GENERATE_LOGINURL_DETAILS,
  CHECK_PAN_EXISTS_FOR_AGENT_DATA,
  GRN_INVOICES_ACTIONTYPE,
  ACTIVITY_CANCELLATION_POLICY_DETAILS,
  TRANSFER_CANCELLATION_POLICY_DETAILS,
  ITINERARY_ID_BY_TEMPID,
  GET_ACTIVITIES_CURRENT_SUPPLIERS,
  VALIDATE_DUPLICATE_BOOKING,
  AGENT_INVOICE_ACTIONTYPE,
  AGENT_INFO_FINALIZE_TRANSFER,
  PRICE_CALCULATE_OC_PC,
  POST_PRICE_CALCULATE,
  AGENTS_BY_CURRENCY,
  BOOKINGS_LIST,
  ADD_TRANSFER_TO_AGENT,
  ADD_FINALIZE_BOOKINGS,
  ADD_DUPLICATE_BOOKING_MAIL_DATA,
  GRN_PROFORMAS_ACTIONTYPE,
  FINALIZE_BOOKINGS_TRANSFER_ADMIN,
  FINALIZED_BOOKINGS_TRANSFER_AGENT,
  ADD_TRANSFER_TO_AGENT_TRANSFER,
  GET_HOTEL_MULTIROOM_MEAN_RATE,
  ACCESS_NOTIFICATIONS,
  GET_HOTEL_INVOICE_ACTIONTYPE,
  GET_EURAIL_INVOICE_ACTIONTYPE,
  GET_ACTIVITY_INVOICE_ACTIONTYPE,
  GET_TRANSFERS_INVOICE_ACTIONTYPE,
  GET_DESTINATION_ACTIVITY,
  BOOKINGDETAILS_BY_ITERNARYID,
  REQUEST_FAILURE_REASON_STATUS,
  AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE,
  SEND_VOUCHER_MAIL_ACTION_TYPE,
  GET_DROP_ACCOMMODATION,
  GET_DROP_AIRPORTS,
  GET_HOTEL_INFO,
  GET_HOTEL_RATES,
  GET_ROOM_OPTIONS_RATES,
  VALIDATE_PAYMENT_LINK,
  VALIDATE_PG_CURRENCY,
} from "../../actionTypes/dashboardActionTypes";
import {
  getSearchLocAction,
  getCurrencyListAction,
  getNationalityListAction,
  getAgentListAction, // TW
  getAgentUsersListAction, // TW
  getCurrenciesByAgentIdAction, // TW
  getCityListAction,
  getHotelSearchAction,
  getHotelsListAction,
  getSearchAddressAction,
  getSearchExtraDetailsAction,
  getHotellevelfilterAction,
  getAirportsAction,
  getAccommodationsAction,
  getDestinationAction,
  getCancellationPolicyAction,
  getBooknowIdAction,
  getRecheckPriceAction,
  getHotelCheckoutDetailsAction,
  getGetAllCurrentSuppliersAction,
  getAgentCreditLimitAction,
  getMailTemplateAction,
  addMailLogAction,
  getAgentByIdAction,
  addAgentQuoteAction,
  getAllActiveAgentsDetailsListAction,
  addUpdateBookingDraftAction,
  bookingDraftByTWBidAction,
  thresholdLimitAdminAction,
  addUpdateBookingUploadAction,
  getCurrencyConversionRatesAction,
  getAirlinesAction,
  getBookingDetailsByBidAction,
  addPGTransactionAction,
  generateHash512Action,
  generateFeaturedHotelsAction,
  validatePANAction,
  updateValidationStatusAction,
  abandonReasonsAction,
  getUserSearchHistoryAction,
  getDMCListAction,
  getDMCCitiesAction,
  getDMCTourTypesAction,
  getDMCPackagesAction,
  getDMCPackDetailsAction,
  setZohoTicketDependencyMappingAction,
  setZohoLayoutRulesAction,
  setZohoTicketCreationAction,
  bookableCLAction,
  bookableWBAction,
  getAgentProfileByAgentIdAction,
  configValueAction,
  previewUrlAction,
  paymentGatewayTransactionsAction,
  getAgentAllWidgetsDataAction,
  postPaymentGatewayAction,
  voucherViewDetailsAction,
  voucherViewEurailDetailsAction,
  biDfromTempIdAction,
  voucherViewTransferDetailsAction,
  voucherViewActivityDetailsAction,
  updatePGInvoiceNumberAction,
  generateLoginUrlAction,
  queryBillingListAction,
  checkPanExistForAgentAction,
  activityCancellationPolicyAction,
  transferCancellationPolicyAction,
  bookableThresholdLimitAction,
  queryItineraryIdByTempIdAction,
  getGetActivitiesCurrentSuppliersAction,
  getValidateDuplicateBookingAction,
  agentInvoiceAction,
  agentInfoFinalizeTransferAction,
  priceCalculateOcPcAction,
  postPriceCalculateAction,
  getAgentsByCurrencyAction,
  queryBookingsListAction,
  addTransferToAgentAction,
  queryAddFinalizeBookingsAction,
  addDuplicateBookingMailDataAction,
  queryProformaAction,
  finalizedBookingsTransferAgentAction,
  finalizeBookingsTransferAdminAction,
  addTransferToAgentTransferAction,
  getHotelMultiRoomMeanRateAction,
  accessNotificationsPermissionsAction,
  getActivityInvoiceAction,
  getEurailInvoiceAction,
  getHotelInvoiceAction,
  getTransfersInvoiceAction,
  getDestinationActivityAction,
  bookingDetailsBasedOnItineraryId,
  addUserSearchHistoryAction,
  requestFailureReasonStatusAction,
  agentsByCurrencyandInvoiceEntityAction,
  sendVoucherMailAction,
  getDropAccommodationsAction,
  getDropAirportsAction,
  getDestinationToAction,
  getHotelInfoAction,
  getHotelRatesAction,
  getRoomOptionsRatesAction,
  getSimilarHotelsAction,
  validatePaymentLinkAction,
  generateInvoicePdfAction,
} from "../../actions/dashboardActions";
import {
  ACTIVE_AGENTS,
  ACTIVE_AGENTSDETAILS,
  ADD_USER_SEARCH_HISTORY_MUTATION,
  ALL_EMPLOYEES_BY_AGENTID,
  CURRENCIES_BY_AGENTID,
  GET_USER_SEARCH_HISTORY_QUERY,
  DMC_CITIES_QUERY_LIST,
  DMC_FEATURED_PACKAGES_QUERY_LIST,
  DMC_PACKAGES_DETAILS_QUERY_LIST,
  DMC_QUERY_LIST,
  DMC_TOURTYPES_QUERY_LIST,
  ZOHO_TICKET_DEPENDENCY_MAPPING,
  ZOHO_LAYOUT_RULES,
  ZOHO_CREATE_TICKET,
} from "../../gqlQueries/Dashboard/searchPageQuery";
import {
  AGENT_PROFILE_INFO,
  GENERATE_LOGINURL,
  GENERATE_NONLOCAL_LOGINURL,
} from "../../gqlQueries/authQuery";
import {
  ADD_AGENTQUOTE,
  ADD_MAIL_LOG,
  ADD_UPDATE_BOOKING_DRAFT,
  ADD_UPDATE_BOOKING_UPLOAD,
  BOOKINGDRAFT_BY_TWBID,
  GET_AGENTBY_ID,
  GET_BOOKINGDETAILS_BY_ITERNARYID,
  GET_CURRENCY_CONVERSION_RATES_QUERY,
  GET_THRESHOLD_LIMIT,
  MAIL_TEMPLATE,
} from "../../gqlQueries/Dashboard/detailPageQuery";
import { getToken, getWrapperToken, isGlobalApolloError } from "../../../utils/helpers/auth";
import {
  ADD_PG_TRANSACTION_CALL_WRAPPER,
  BOOKING_DETAILS_BY_BID,
  GENERATE_HASH512_WRAPPER,
  GET_ACCOMMODATION_WRAPPER,
  GET_ADDRESSES_WRAPPER,
  GET_AIRLINES_QUERY,
  GET_AIRPORT_WRAPPER,
  GET_CANCELLATIONPOLICY_WRAPPER,
  GET_CHECKOUT_WRAPPER,
  GET_CITY_BY_COUNTRY_WRAPPER,
  GET_CURRENCY_LIST_WRAPPER,
  GET_DESTINATION_WRAPPER,
  GET_EXTRADETAILS_WRAPPER,
  GET_GETACTIVITIESCURRENTSUPPLIERS_WRAPPER,
  GET_GETALLCURRENTSUPPLIERS_WRAPPER,
  GET_HOTELLEVELFILTER_WRAPPER,
  GET_HOTELSEARCH_WRAPPER,
  GET_HOTELSLIST_WRAPPER,
  GET_LOCATIONS_WRAPPER,
  GET_NATIONALITIES_QUERY,
  GET_PREBOOK_WRAPPER,
  UPDATE_VALIDATION_STATUS_MUTATION,
  VALIDATE_PANS_WRAPPER,
  ADD_DUPLICATE_BOOKING_MAIL_DATA_QUERY,
  MULTIROOM_MEAN_RATE_WRAPPER,
  GET_DESTINATION_ACTIVITY_WRAPPER,
  GET_HOTEL_INFO_WRAPPER,
  GET_HOTEL_RATES_WRAPPER,
  GET_ROOM_OPTIONS_RATES_WRAPPER,
} from "../../gqlQueries/Dashboard/grnQuery";
import { GENERATE_FEATURED_HOTELS_WRAPPER } from "../../gqlQueries/Dashboard/searchResultsQuery";
import {
  ADD_FINALIZE_BOOKINGS_QUERY,
  ADD_TRANSFER_TO_AGENT_MUTATION,
  AGENT_INFO_FINALIZE_TRANSFER_QUERY,
  AGENT_PROFILE_BY_ID_QUERY,
  BID_FROM_TEMP_ID_QUERY,
  BOOKABLE_CL_DETAILS_QUERY,
  BOOKABLE_THRESHOLD_LIMIT_DETAILS_QUERY,
  BOOKABLE_WB_DETAILS_QUERY,
  CHECK_PAN_EXISTS_FOR_AGENT_DATA_QUERY,
  GET_ABANDON_REASONS,
  GET_AGENTS_BY_CURRENCY_QUERY,
  GET_BOOKINGS_LIST_BY_GRN,
  GET_ITINERARY_ID_BY_TEMPID_QUERY,
  GET_PAYMENT_GATEWAY_TRANSACTIONS_QUERY,
  GRN_INVOICES_LIST,
  POST_PAYMENT_GATEWAY_MUTATION,
  POST_PRICE_CALCULATE_MUTATION,
  PRICE_CALCULATE_OC_PC_QUERY,
  UPDATE_PG_INVOICE_NUMBER_QUERY,
  VALIDATE_DUPLICATE_BOOKING_QUERY,
  VOUCHER_VIEW_ACTIVITY_DETAILS_QUERY,
  VOUCHER_VIEW_DETAILS_QUERY,
  VOUCHER_VIEW_TRANSFER_DETAILS_QUERY,
  VOUCHER_VIEW_EURAIL_DETAILS_QUERY,
  ADD_FINALIZE_BOOKINGS_TRANSFER_ADMIN,
  ADD_FINALIZED_BOOKINGS_TRANSFER_AGENT,
  ADD_TRANSFER_TO_AGENT_TRASFER_MUTATION,
  ACCESS_NOTIFICATIONS_QUERY,
  REQUEST_FAILURE_REASON_STATUS_MUTATION,
  AGENTS_BY_CURRENCY_AND_INVOICEENTITY_QUERY,
  SEND_VOUCHER_MAIL,
  VALIDATE_PAYMENT_LINK_MUTATION,
  VALIDATE_PG_CURRENCY_QUERY,
} from "../../gqlQueries/Dashboard/bookingsQuery";
import { CONFIG_VALUE_QUERY } from "../../gqlQueries/homeQuery";
import {
  ACTIVITY_CANCELLATION_POLICY_WRAPPER_MUTATION,
  ACTIVITY_INVOICE_QUERY,
  ACTIVITY_PROFORMA_INVOICE_QUERY,
  AGENT_ALL_WIDGETS_DATA_QUERY,
  AGENT_INVOICE_QUERY,
  EURAIL_INVOICE_QUERY,
  EURAIL_PROFORMA_INVOICE_QUERY,
  GENERATE_INVOICE_PDF_QUERY,
  HOTEL_INVOICE_QUERY,
  HOTEL_PROFORMA_INVOICE_QUERY,
  PREVIEW_URL_QUERY,
  TRANSFERS_INVOICE_QUERY,
  TRANSFER_CANCELLATION_POLICY_WRAPPER_MUTATION,
  TRANSFER_PROFORMA_INVOICE_QUERY,
} from "../../gqlQueries/Dashboard/dashboardQuery";
import { decryptAPIData, encryptAPIData } from "../../../utils/helpers/common";
import { getNotificationMessage } from "../../actions/localStorageActions";
import { UIMessage } from "../../../components/UI/UIMessage";
import engLang from "../../../locales/languages/Dashboard/DashboardEng.json";
import spanLang from "../../../locales/languages/Dashboard/DashboardSpan.json";
import { getLanguageCode } from "../../../locales/getlanguagecode";
import { customNotify } from "../../../components/UI/ToastNotify";
import secureLocalStorage from "react-secure-storage";

function* getSearchLoc(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    location: action?.payload?.location,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_LOCATIONS_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.location?.responseData?.status?.toLowerCase() === "success" &&
      data?.data?.location?.responseData?.data
    ) {
      yield put(
        getSearchLocAction.FULLFILLED({
          data: data?.data?.location?.responseData,
        }),
      );
    } else {
      yield put(getSearchLocAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.promtsMessages?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.promtsMessages?.fetchlocation
        }.`,
      closeIcon: true,
    });
    yield put(getSearchLocAction.REJECTED());
  }
}
function* generateInvoicePdfSaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      invoicePdfVM: action?.payload?.invoicePdfVM,
    };

    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GENERATE_INVOICE_PDF_QUERY,
      clientType: "MO",
      data: customHeaders,
    });

    const responseData = Array.isArray(queryResp?.data?.generateInvoicePdf)
      ? queryResp?.data?.generateInvoicePdf?.[0]
      : queryResp?.data?.generateInvoicePdf;

    action?.payload?.onSuccess?.(responseData);
    action?.payload?.onFinally?.();
    yield put(generateInvoicePdfAction.FULLFILLED(responseData));
  } catch (error) {
    action?.payload?.onError?.(error);
    action?.payload?.onFinally?.();
    yield put(generateInvoicePdfAction.REJECTED(String(error)));
  }
}
function* getCurrencyList(): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
    };

    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_CURRENCY_LIST_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.currency?.successTypeCode?.toLowerCase() == "success" &&
      apiData?.data?.currency?.responseData?.status?.toLowerCase() == "success"
    ) {
      yield put(
        getCurrencyListAction.FULLFILLED({
          data: apiData?.data?.currency?.responseData,
        }),
      );
    } else {
      yield put(getCurrencyListAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getCurrencyListAction.REJECTED());
  }
}

function* getNationalityList(): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
      },
    };

    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_NATIONALITIES_QUERY,
      clientType: "MO",
      data: customHeaders,
    });

    if (data?.data?.nationalityMasterList?.responseData) {
      const changePropertyName =
        data?.data?.nationalityMasterList?.responseData?.map(
          (item: { name: string }) => {
            return { ...item, code: item?.name };
          },
        );

      yield put(
        getNationalityListAction.FULLFILLED({
          data: { data: changePropertyName },
        }),
      );
    } else {
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.nationalities_not_available,
        closeIcon: true,
      });
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(getNationalityListAction.REJECTED());
  }
}

function* getCityList(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      country: action?.payload,
    };

    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_CITY_BY_COUNTRY_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.city?.successTypeCode?.toLowerCase() == "success" &&
      apiData?.data?.city?.responseData?.status?.toLowerCase() == "success"
    ) {
      yield put(
        getCityListAction.FULLFILLED({
          data: apiData?.data?.city?.responseData,
        }),
      );
    } else {
      yield put(getCityListAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getCityListAction.REJECTED());
  }
}

function* getDestinationDropboxList(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    location: action?.payload?.location,
    searchKey: action?.payload?.searchKey || "",
    hubSearchId: action?.payload?.hubSearchId || "",
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_DESTINATION_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.destination?.successTypeCode?.toLowerCase() == "success" &&
      data?.data?.destination?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.destination?.responseData
    ) {
      yield put(
        getDestinationAction.FULLFILLED({
          data: data?.data?.destination?.responseData,
          status: 200,
        }),
      );
      action?.payload?.setError && action?.payload?.setError(false);
    } else {
      action?.payload?.setError && action?.payload?.setError(true);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.getDestinationDropboxList
        ?.Something_went_wrong_Unable_to_fetch_locations,
      closeIcon: true,
    });
    yield put(getDestinationAction.REJECTED());
  }
}

function* getDestinationToDropboxList(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    location: action?.payload?.location,
    searchKey: action?.payload?.searchKey || "",
    hubSearchId: action?.payload?.hubSearchId || "",
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_DESTINATION_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.destination?.successTypeCode?.toLowerCase() == "success" &&
      data?.data?.destination?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.destination?.responseData
    ) {
      yield put(
        getDestinationToAction.FULLFILLED({
          data: data?.data?.destination?.responseData,
          status: 200,
        })
      );
      action?.payload?.setError && action?.payload?.setError(false);
    } else {
      action?.payload?.setError && action?.payload?.setError(true);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.getDestinationToDropboxList
        ?.Something_went_wrong_Unable_to_fetch_locations,
      closeIcon: true,
    });
    yield put(getDestinationToAction.REJECTED());
  }
}

function* getDestinationActivityDropboxList(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    location: action?.payload?.location,
    searchKey: action?.payload?.searchKey || "",
    hubSearchId: action?.payload?.hubSearchId || "",
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_DESTINATION_ACTIVITY_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.destinationNew?.successTypeCode?.toLowerCase() == "success" &&
      data?.data?.destinationNew?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.destinationNew?.responseData
    ) {
      yield put(
        getDestinationActivityAction.FULLFILLED({
          data: data?.data?.destinationNew?.responseData,
          status: 200,
        }),
      );
      action?.payload?.setError && action?.payload?.setError(false);
    } else {
      action?.payload?.setError && action?.payload?.setError(true);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.getDestinationActivityDropboxList
        ?.Something_went_wrong_Unable_to_fetch_locations,
      closeIcon: true,
    });
    yield put(getDestinationActivityAction.REJECTED());
  }
}

// TW API
function* getAgentList(action: any): any {
  try {
    const customHeaders = {
      headers: action?.payload?.headers,
      searchItem: action?.payload?.searchItem,
    };
    const agentData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ACTIVE_AGENTS,
      clientType: "MO",
      data: customHeaders,
    });
    yield put(getAgentListAction.FULLFILLED(agentData));
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.fetchrecordforAgent
        }.`,
      closeIcon: true,
    });
    yield put(getAgentListAction.REJECTED());
  }
}

// TW API
function* getAllActiveAgentsDetailsList(action: any): any {
  try {
    const agentData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ACTIVE_AGENTSDETAILS,
      clientType: "MO",
      data: action?.payload,
    });
    yield put(getAllActiveAgentsDetailsListAction.FULLFILLED(agentData));
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: `${getLanguageCode(engLang, spanLang)?.promtsMessages?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.promtsMessages?.fetchrecordforAgent
        }.`,
      closeIcon: true,
    });
    yield put(getAllActiveAgentsDetailsListAction.REJECTED());
  }
}

// TW API
function* getAgentUsersList(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
      },
      agent_info_id: action?.payload?.agent_info_id,
    };
    const agentUserData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ALL_EMPLOYEES_BY_AGENTID,
      clientType: "MO",
      data: customHeaders,
    });
    yield put(getAgentUsersListAction.FULLFILLED(agentUserData));
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: `${getLanguageCode(engLang, spanLang)?.promtsMessages?.wentwrong
        }, ${getLanguageCode(engLang, spanLang)?.promtsMessages?.fetchrecordforAgent
        }.`,
      closeIcon: true,
    });
    yield put(getAgentUsersListAction.REJECTED());
  }
}

// TW API
function* getCurrenciesByAgentId(action: any): any {
  try {
    const currenciesData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: CURRENCIES_BY_AGENTID,
      clientType: "MO",
      data: action?.payload,
    });
    yield put(getCurrenciesByAgentIdAction.FULLFILLED(currenciesData));
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.fetchCurrency
        }.`,
      closeIcon: true,
    });
    yield put(getCurrenciesByAgentIdAction.REJECTED());
  }
}

function* getHotelSearch(action: any): any {
  const { getProductSearchTimeExpire, mypayload } = action.payload || {};
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "x-GRN-LoggedInUser": "dummyuser",
      "x-GRN-clientId": "GRNClient",
      "x-GRN-secret": "GRNSecret",
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    hotelSearchDTO: JSON.stringify(mypayload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_HOTELSEARCH_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.postHotelSearch?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.postHotelSearch?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      yield put(
        getHotelSearchAction.FULLFILLED({
          data: apiData?.data?.postHotelSearch?.responseData,
          status: 200,
        }),
      );
      getProductSearchTimeExpire?.(apiData?.data?.postHotelSearch?.responseData);
    } else {
      yield put(getHotelSearchAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getHotelSearchAction.REJECTED());
  }
}

// hotels list api
function* getHotelsList(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      sId: action?.payload?.sId,
      cityId: action?.payload?.cityId,
    };

    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_HOTELSLIST_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.hotelsList?.successTypeCode?.toLowerCase() == "success" &&
      apiData?.data?.hotelsList?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      yield put(
        getHotelsListAction.FULLFILLED({
          data: apiData?.data?.hotelsList?.responseData,
        }),
      );
    } else {
      yield put(getHotelsListAction.REJECTED());
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getHotelsListAction.REJECTED());
    action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
  }
}

// hotels addresses api
function* getHotelsAddresses(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      sId: action?.payload?.sId,
    };

    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_ADDRESSES_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.addresses?.successTypeCode?.toLowerCase() == "success" &&
      apiData?.data?.addresses?.responseData?.status?.toLowerCase() == "success"
    ) {
      yield put(
        getSearchAddressAction.FULLFILLED({
          data: apiData?.data?.addresses?.responseData,
        }),
      );
    } else {
      yield put(getSearchAddressAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getSearchAddressAction.REJECTED());
  }
}

// hotel extra details api
function* getExtraDetails(action: any): any {
  try {
    // If map exists, handle multiple hotelid chunks
    if (action?.payload?.setCustomImage && action?.payload?.request?.hotelid) {
      const hotelIds = action.payload.request.hotelid;
      const chunkSize = 150;
      const chunks: string[][] = [];
      for (let i = 0; i < hotelIds.length; i += chunkSize) {
        chunks.push(hotelIds.slice(i, i + chunkSize));
      }

      let allResults: any[] = [];
      for (const chunk of chunks) {
        const customHeaders = {
          headers: {
            Authorization: getToken() && `Bearer ${getToken()}`,
            "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
          },
          sid: action?.payload?.request?.sid,
          hotelid: chunk.join(","),
        };

        const apiData = yield call(newRequest, {
          callType: "apollo",
          callMethod: "query",
          dataQuery: GET_EXTRADETAILS_WRAPPER,
          clientType: "BE",
          data: customHeaders,
        });

        if (
          apiData?.data?.extraDetails?.successTypeCode?.toLowerCase() ==
          "success" &&
          apiData?.data?.extraDetails?.responseData?.status?.toLowerCase() ==
          "success"
        ) {
          const result = apiData?.data?.extraDetails?.responseData?.data;
          if (Array.isArray(result)) {
            allResults = allResults.concat(result);
          }
        }
        // Wait for 500ms before next call
        yield new Promise((resolve) => setTimeout(resolve, 500));
      }
      action?.payload?.setDataLoading?.(false);
      yield put(
        getSearchExtraDetailsAction.FULLFILLED({
          data: allResults,
          setCustomImage: action?.payload?.setCustomImage,
        }),
      );
    } else {
      // Single call for non-customImage case
      const customHeaders = {
        headers: {
          Authorization: getToken() && `Bearer ${getToken()}`,
          "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
        },
        sid: action?.payload?.request?.sid,
        hotelid: action?.payload?.request?.hotelid,
      };

      const apiData = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: GET_EXTRADETAILS_WRAPPER,
        clientType: "BE",
        data: customHeaders,
      });

      action?.payload?.setDataLoading?.(false);

      if (
        apiData?.data?.extraDetails?.successTypeCode?.toLowerCase() ==
        "success" &&
        apiData?.data?.extraDetails?.responseData?.status?.toLowerCase() ==
        "success"
      ) {
        yield put(
          getSearchExtraDetailsAction.FULLFILLED(
            apiData?.data?.extraDetails?.responseData?.data,
          ),
        );
      } else {
        yield put(getSearchExtraDetailsAction.REJECTED());
      }
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getSearchExtraDetailsAction.REJECTED());
  }
}

// hotel level filter api
function* getHotellevelfilter(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    sId: action?.payload?.sId,
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_HOTELLEVELFILTER_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.hotelLevelFilter?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.hotelLevelFilter?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      yield put(
        getHotellevelfilterAction.FULLFILLED({
          data: apiData?.data?.hotelLevelFilter?.responseData,
        }),
      );
    } else {
      yield put(getHotellevelfilterAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getHotellevelfilterAction.REJECTED());
  }
}

function* getHotelInfo(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      hotelInfoDTO: JSON.stringify({
        hotelId: action?.payload?.hotelId,
        sid: action?.payload?.sid,
        sKey: action?.payload?.sKey,
      }),
    };
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_HOTEL_INFO_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.hotelInfo?.successTypeCode?.toLowerCase() == "success" &&
      apiData?.data?.hotelInfo?.responseData?.status?.toLowerCase() == "success"
    ) {
      yield put(
        getHotelInfoAction.FULLFILLED({
          data: apiData?.data?.hotelInfo?.responseData,
        }),
      );
    } else {
      UIMessage({
        messageText:
          apiData?.data?.hotelInfo?.responseData?.message ||
          "Hotel data not available",
        btnText: "Go to Home Page",
        onClose: () => {
          action?.payload?.navigate && action?.payload?.navigate("/");
        },
        closeIcon: true,
      });
      yield put(getHotelInfoAction.REJECTED());
    }
    action.payload.setPageLoading && action.payload.setPageLoading(false);
    action.payload.setIsPageLoading && action.payload.setIsPageLoading(false);
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: `${getLanguageCode(engLang, spanLang)?.promtsMessages?.timeoutmessage
        }`,
      closeIcon: true,
    });
    yield put(getHotelInfoAction.REJECTED());
    action?.payload?.setPageLoading(false);
  }
}

function* getHotelRates(action: any): any {
  const { hotelId, sid, sKey, setAreRoomsLoaded, onRateExpired } =
    action.payload || {};
  const getHeaders = (dtoKey: string, dtoValue: any) => ({
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    [dtoKey]: JSON.stringify(dtoValue),
  });

  // const isSoftError = (response: any) => {
  //   const msg = response?.message?.toLowerCase() || "";
  //   const errMsg = response?.errorMessage?.toLowerCase() || "";
  //   return (
  //     msg.includes("rates expired") ||
  //     msg.includes("no rate found") ||
  //     errMsg.includes("rates expired") ||
  //     errMsg.includes("no rate found")
  //   );
  // };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_HOTEL_RATES_WRAPPER,
      clientType: "BE",
      data: getHeaders("hotelRatesDTO", { hotelId, sid, sKey }),
    });
    const initialRes = apiData?.data?.hotelRates;
    const initialResData = initialRes?.responseData;

    const isInitialSuccess =
      initialRes?.successTypeCode?.toLowerCase() == "success" &&
      initialResData?.status?.toLowerCase() === "success";

    if (isInitialSuccess) {
      yield put(
        getHotelRatesAction.FULLFILLED({
          data: initialResData,
        }),
      );
      yield put(
        getSimilarHotelsAction.FULLFILLED(
          initialResData?.data?.similar_hotels || null,
        ),
      );
      setAreRoomsLoaded && setAreRoomsLoaded(true);
    } else {
      // ==========================================
      // 3. INITIAL CALL FAILURE HANDLING
      // ==========================================
      const errorMsg = initialResData?.message || "";
      UIMessage({
        messageText:
          errorMsg.toLowerCase() === "rates expired"
            ? "The price that is listed might have changed. We recommend you to search again."
            : errorMsg || "Room options not available",
        closeIcon: true,
        onClose: () => {
          onRateExpired?.();
        },
      });
      yield put(getRoomOptionsRatesAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: `${getLanguageCode(engLang, spanLang)?.promtsMessages?.wentwrong
        }`,
      closeIcon: true,
    });
    yield put(getHotelRatesAction.REJECTED());
  }
}

function* getRoomOptionsRates(action: any): any {
  const {
    hotelRoomOptions,
    // navigate,
    setIsRoomTabLoading,
    setLoader,
    setAreRoomsLoaded,
    stopMeanRateApi,
  } = action.payload.roomOptionpayload || {};
  const multiRoomMeanRatePayload =
    action.payload.multiRoomMeanRatePayload || {};
  const onRateExpired =
    action.payload.onRateExpired || {};
  // Helper to generate headers dynamically
  const getHeaders = (dtoKey: string, dtoValue: any) => ({
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    [dtoKey]: JSON.stringify(dtoValue),
  });

  try {
    // ==========================================
    // 1. INITIAL ROOM OPTIONS CALL
    // ==========================================
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_ROOM_OPTIONS_RATES_WRAPPER,
      clientType: "BE",
      data: getHeaders("input", hotelRoomOptions), // uses 'input' key based on your original code
    });

    const initialRes = apiData?.data?.roomOptionsRates;
    const initialResData = initialRes?.responseData;

    const isInitialSuccess =
      initialResData?.status?.toLowerCase() === "success" &&
      initialResData?.data;

    if (isInitialSuccess) {
      yield put(getRoomOptionsRatesAction.FULLFILLED(initialResData.data));
      setIsRoomTabLoading && setIsRoomTabLoading(false);
      yield put(
        getSimilarHotelsAction.FULLFILLED(
          initialResData?.data?.similar_hotels || null,
        ),
      );

      setAreRoomsLoaded && setAreRoomsLoaded(true);

      if (!stopMeanRateApi)
        yield put(
          getHotelMultiRoomMeanRateAction.STARTED(multiRoomMeanRatePayload),
        );
    } else {
      // ==========================================
      // 3. INITIAL CALL FAILURE HANDLING
      // ==========================================
      const errorMsg = initialResData?.message || "";
      UIMessage({
        messageText:
          errorMsg.toLowerCase() === "rates expired"
            ? "The price that is listed might have changed. We recommend you to search again."
            : errorMsg || "Room options not available",
        closeIcon: true,
        onClose: () => {
          // hotelRoomOptions?.sid
          //   ? navigate(
          //     `/hotel-search-results?searchkey=${hotelRoomOptions.sid}`,
          //   )
          //   : navigate(-1);
          onRateExpired?.();
        },
      });
      yield put(getRoomOptionsRatesAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    setLoader && setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.promtsMessages
        ?.wentwrong,
      closeIcon: true,
    });
    yield put(getRoomOptionsRatesAction.REJECTED());
  }
}

function* getHotelMultiroomMeanRate(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      input: JSON.stringify(action?.payload),
    };
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: MULTIROOM_MEAN_RATE_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      apiData &&
      apiData?.data?.postMeanRate?.responseData?.status?.toLowerCase() ==
      "success" &&
      apiData?.data?.postMeanRate?.responseData?.data
    ) {
      yield put(
        getHotelMultiRoomMeanRateAction.FULLFILLED(
          apiData?.data?.postMeanRate?.responseData?.data,
        ),
      );
    } else {
      yield put(getHotelMultiRoomMeanRateAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.promtsMessages
        ?.mean_rate_msg,
      closeIcon: true,
    });
    yield put(getHotelMultiRoomMeanRateAction.REJECTED());
  }
}

function* getGetAllCurrentSuppliers(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      sId: action?.payload?.sId,
    };

    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_GETALLCURRENTSUPPLIERS_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.allCurrentSuppliers?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.allCurrentSuppliers?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      yield put(
        getGetAllCurrentSuppliersAction.FULLFILLED({
          data: apiData?.data?.allCurrentSuppliers?.responseData,
        }),
      );
    } else {
      yield put(getGetAllCurrentSuppliersAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getGetAllCurrentSuppliersAction.REJECTED());
  }
}

function* getGetActivitiesCurrentSuppliers(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      searchKey: action?.payload?.searchKey,
    };

    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_GETACTIVITIESCURRENTSUPPLIERS_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.activitySuppliers?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.activitySuppliers?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      yield put(
        getGetActivitiesCurrentSuppliersAction.FULLFILLED({
          data: apiData?.data?.activitySuppliers?.responseData,
        }),
      );
    } else {
      yield put(getGetActivitiesCurrentSuppliersAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getGetActivitiesCurrentSuppliersAction.REJECTED());
  }
}

function* getAirports(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    id: action?.payload?.id,
    searchKey: action?.payload?.searchKey || "",
    hubSearchId: action?.payload?.hubSearchId || "",
  };

  if (action?.payload?.id) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: GET_AIRPORT_WRAPPER,
        clientType: "BE",
        data: customHeaders,
      });
      action?.payload?.setLoader &&
        Promise.resolve().then(() =>
          action?.payload?.setLoader?.({
            ...action?.payload?.isAirAccLoader,
            air: false,
          })
        );
      if (
        data?.data?.airport?.successTypeCode?.toLowerCase() == "success" &&
        data?.data?.airport?.responseData?.status?.toLowerCase() == "success" &&
        data?.data?.airport?.responseData
      ) {
        yield put(
          getAirportsAction.FULLFILLED({
            data: data?.data?.airport?.responseData,
            status: 200,
          }),
        );
      } else {
        UIMessage({
          messageText: getLanguageCode(engLang, spanLang)
            ?.Airports_not_available,
          closeIcon: true,
        });
        yield put(getAirportsAction.REJECTED());
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoader?.({
        ...action?.payload?.isAirAccLoader,
        air: false,
      });
      yield put(getAirportsAction.REJECTED());
    }
  }
}

function* getDropAirports(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    id: action?.payload?.id,
    searchKey: action?.payload?.searchKey || "",
    hubSearchId: action?.payload?.hubSearchId || "",
  };

  if (action?.payload?.id) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: GET_AIRPORT_WRAPPER,
        clientType: "BE",
        data: customHeaders,
      });
      action?.payload?.setLoader &&
        Promise.resolve().then(() =>
          action?.payload?.setLoader?.({
            ...action?.payload?.isAirAccLoader,
            air: false,
          })
        );

      if (
        data?.data?.airport?.successTypeCode?.toLowerCase() == "success" &&
        data?.data?.airport?.responseData?.status?.toLowerCase() == "success" &&
        data?.data?.airport?.responseData
      ) {
        yield put(
          getDropAirportsAction.FULLFILLED({
            data: data?.data?.airport?.responseData,
            status: 200,
          })
        );
      } else {
        UIMessage({
          messageText: getLanguageCode(engLang, spanLang)
            ?.Airports_not_available,
          closeIcon: true,
        });
        yield put(getDropAirportsAction.REJECTED());
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoader?.({
        ...action?.payload?.isAirAccLoader,
        air: false,
      });
      yield put(getDropAirportsAction.REJECTED());
    }
  }
}

function* getAirlines(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    searchKey: action?.payload?.search_key || "",
    hubSearchId: action?.payload?.hubSearchId || "",
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_AIRLINES_QUERY,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.transfersAirlines?.responseData?.data &&
      Array.isArray(data?.data?.transfersAirlines?.responseData?.data) &&
      data?.data?.transfersAirlines?.responseData?.data?.length > 0
    ) {
      yield put(
        getAirlinesAction.FULLFILLED({
          data: data?.data?.transfersAirlines?.responseData?.data,
          status: 200,
        }),
      );
    } else {
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)?.Airlines_not_available,
        closeIcon: true,
      });
      yield put(getAirlinesAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.fetchlocation
        }.`,
      closeIcon: true,
    });
    yield put(getAirlinesAction.REJECTED());
  }
}

function* getAccommodations(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    id: action?.payload?.id,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_ACCOMMODATION_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader &&
      Promise.resolve().then(() =>
        action?.payload?.setLoader?.({
          ...action?.payload?.isAirAccLoader,
          acc: false,
        })
      );
    if (
      data?.data?.accommodation?.successTypeCode?.toLowerCase() == "success" &&
      data?.data?.accommodation?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.accommodation?.responseData
    ) {
      yield put(
        getAccommodationsAction.FULLFILLED({
          data: data?.data?.accommodation?.responseData,
          status: 200,
        }),
      );
    } else {
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.Accommodations_not_available,
        closeIcon: true,
      });
      yield put(getAccommodationsAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader?.({
      ...action?.payload?.isAirAccLoader,
      acc: false,
    });
    UIMessage({
      messageText: `${getLanguageCode(engLang, spanLang)?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.pleasetryAgain}.`,
      closeIcon: true,
    });
    yield put(getAccommodationsAction.REJECTED());
  }
}

function* getDropAccommodations(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    id: action?.payload?.id,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_ACCOMMODATION_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader &&
      Promise.resolve().then(() =>
        action?.payload?.setLoader?.({
          ...action?.payload?.isAirAccLoader,
          acc: false,
        })
      );
    if (
      data?.data?.accommodation?.successTypeCode?.toLowerCase() == "success" &&
      data?.data?.accommodation?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.accommodation?.responseData
    ) {
      yield put(
        getDropAccommodationsAction.FULLFILLED({
          data: data?.data?.accommodation?.responseData,
          status: 200,
        })
      );
    } else {
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.Accommodations_not_available,
        closeIcon: true,
      });
      yield put(getDropAccommodationsAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader?.({
      ...action?.payload?.isAirAccLoader,
      acc: false,
    });
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.pleasetryAgain
        }.`,
      closeIcon: true,
    });
    yield put(getDropAccommodationsAction.REJECTED());
  }
}

function* getHotelCancellationPolicy(action: any): any {
  const { hotelSid, hotelId, rateKey } = action.payload;
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify({
      sid: hotelSid,
      hotelCode: hotelId,
      rateKey: rateKey,
    }),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_CANCELLATIONPOLICY_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.cancellationPolicy?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.cancellationPolicy?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      if (action?.payload?.cancellationPolicyResponse && action?.payload?.cancellationPolicyResponse) {
        action?.payload?.cancellationPolicyResponse(apiData?.data?.cancellationPolicy?.responseData);
      }
      yield put(
        getCancellationPolicyAction.FULLFILLED({
          data: apiData?.data?.cancellationPolicy?.responseData,
        }),
      );
    } else {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      UIMessage({
        messageText: `${getLanguageCode(engLang, spanLang)?.wentwrong},${apiData?.data?.cancellationPolicy?.responseData?.errorMessage?.[0]
          ?.errormessage
          }`,
        closeIcon: true,
      });
      yield put(getCancellationPolicyAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.wentwrong}, ${error?.data?.errorMessage[0]["errormessage"]
        }.`,
      closeIcon: true,
    });
    yield put(getCancellationPolicyAction.REJECTED());
  }
}

// Booking Process Starts here
function* getBooknowId(action: any): any {
  const { booknowPayload, onRateExpired } = action.payload || {};
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    preBookDTO: encryptAPIData(JSON.stringify(booknowPayload?.apiPayload)),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_PREBOOK_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (apiData?.data?.postPreBook) {
      const decodedApiData = apiData?.data?.postPreBook?.responseData;
      // const decodedApiData = responseData ? JSON.parse(decryptAPIData(responseData)) : {};

      if (
        apiData?.data?.postPreBook?.successTypeCode?.toLowerCase() == "success"
      ) {
        booknowPayload?.setLoader && booknowPayload?.setLoader(false);
        yield put(
          getBooknowIdAction.FULLFILLED({
            data: decodedApiData,
            status: 200,
          }),
        );
      } else {
        booknowPayload?.setLoader && booknowPayload?.setLoader(false);
        const message = getLanguageCode(engLang, spanLang)?.rate_error_2;
        // if (decodedApiData?.message) {
        //   message = decodedApiData?.message;
        // } else if (decodedApiData?.errorMessage) {
        //   message = decodedApiData?.errorMessage;
        // }
        UIMessage({
          messageText: message,
          closeIcon: true,
          onClose: () => {
            onRateExpired?.();
          },
        });
        yield put(getBooknowIdAction.REJECTED());
      }
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: `${getLanguageCode(engLang, spanLang)?.timeoutmessage}.`,
      closeIcon: true,
    });
    yield put(getBooknowIdAction.REJECTED());
  }
}

function* getRecheckPrice(action: any): any {
  try {
    const apiData = yield call(newRequest, {
      url: "/Book/pricing",
      method: "POST",
      callType: "axios",
      params: {
        BookingId: action?.payload,
      },
    });

    if (apiData && apiData?.data?.status == "success") {
      yield put(getRecheckPriceAction.FULLFILLED(apiData));
    }
    if (apiData && apiData?.data?.status == "fail") {
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.Failed_to_fetch_updated_price,
        closeIcon: true,
      });
      yield put(getRecheckPriceAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.wentwrong},${error?.data?.errorMessage[0]["errormessage"]
        }`,
      closeIcon: true,
    });
    yield put(getRecheckPriceAction.REJECTED());
  }
}

function* getHotelCheckoutDetails(action: any): any {
  // console.log('actionpayloadasa', action.payload)
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    bookingDetails: encryptAPIData(
      JSON.stringify({
        bookingDetails: JSON.stringify(action?.payload?.apiPayload) || null,
        sid: action?.payload?.sid || null,
        hubSearchId: action?.payload?.hubSearchId || null,
      }),
    ),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_CHECKOUT_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader(false);
    if (apiData?.data?.postCheckOut?.responseData) {
      const decryptedData = JSON.parse(
        decryptAPIData(apiData?.data?.postCheckOut?.responseData),
      );

      if (
        apiData?.data?.postCheckOut?.successTypeCode?.toLowerCase() ==
        "success" &&
        decryptedData?.status?.toLowerCase() == "success"
      ) {
        action?.payload?.getCheckoutDetails?.(
          decryptedData?.data?.status?.toLowerCase(),
        );
        yield put(
          getHotelCheckoutDetailsAction.FULLFILLED({
            data: decryptedData,
            status: 200,
          }),
        );
      } else {
        if (action?.payload?.callingFrom == "online") {
          setTimeout(() => {
            window.location.href = "/";
          }, 5000);
        }

        action?.payload?.setLoader(false);
        action?.payload?.getCheckoutDetails?.(
          decryptedData?.data?.status?.toLowerCase(),
        );
        yield put(
          getHotelCheckoutDetailsAction.REJECTED({
            data: decryptedData,
            status: 500,
          }),
        );
      }
    } else {
      if (action?.payload?.callingFrom == "online") {
        setTimeout(() => {
          window.location.href = "/";
        }, 5000);
      }
      action?.payload?.getCheckoutDetails?.("pending");
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    if (action?.payload?.callingFrom == "online") {
      setTimeout(() => {
        window.location.href = "/";
      }, 5000);
    }
    action?.payload?.getCheckoutDetails?.("pending");
    action?.payload?.setLoader(false);
    yield put(getHotelCheckoutDetailsAction.REJECTED(error));
  }
}
// Booking Process Ends here

export function* queryAgentCreditLimit(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: `Bearer ${action?.payload}`,
      },
    };
    const AgentProfileData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: AGENT_PROFILE_INFO,
      clientType: "MO",
      data: customHeaders,
    });

    if (
      AgentProfileData?.data?.agentProfile?.successTypeCode?.toLowerCase() ==
      "success" &&
      AgentProfileData?.data?.agentProfile?.responseData
    ) {
      const finalResponseData = JSON.parse(
        decryptAPIData(AgentProfileData?.data?.agentProfile?.responseData),
      );
      const finalAgentProfileData = {
        data: {
          agentProfile: {
            ...AgentProfileData?.data?.agentProfile,
            responseData: finalResponseData,
          },
        },
      };
      if (
        finalAgentProfileData?.data?.agentProfile?.responseData != null ||
        finalAgentProfileData?.data?.agentProfile?.responseData[0] != null
      ) {
        // need to remove before push
        // const temp=[{"user_id":"fb7567cc-273a-4ee7-8dfe-c1aa840d6994","agent_id":"350b3804-6bdc-4e50-91a6-3ec96fb28fe9","agent_number":1024,"l1_agent_number":1024,"hierarchy":"L1","preferred_currency":"INR","invoice_currency":"INR","approval_status":2,"country_code":"IN","contact_person":"Dheeraj Gupta","email":"dom1@mailinator.com","agency_email":"dom1@mailinator.com","max_credit_limit":1200000.0,"wallet_balance":447791.0,"wallet_balance_from_parent":null,"parent_id":"3189d4f0-61d3-411e-b8c7-38f1926d8339","bookable_credit_limit":2939966806.0,"allocated_credit_limit":1175099.0,"available_credit_limit":2941968062.0,"max_threshold_limit":117679548.0,"allocated_threshold_limit":89442763.0,"available_threshold_limit":6624111.0,"bookable_threshold_limit":1188282.0,"agent_name":"DHEERAJ GUPTA","is_cl_enabled":true,"is_premium_agent":false,"is_temp_cl_enabled":false,"cl_from_date":null,"cl_to_date":null,"sales_spoc":"sales  head","sales_spoc_phone":"+91 9696969696","sales_spoc_email":"saleshead@mailinator.com","ops_spoc":"Pragati  sheel","ops_spoc_phone":"9999999999","ops_spoc_email":"grnconnectit@mailinator.com","head_operation_email":null,"empolyee_agent_id":null,"employee_hierarchy":null,"employee_name":null,"api_key":"7ec2f0d01282847b05b6ad6b499ba005","invoicing_entity":"SKT","online_payment_enabled":true,"online_payment_surchage":true,"online_payment_surcharge_inclusive":true,"permissions":["update_booking_status","update_payment_mode","update_agent_supplier_mapping","amend_booking","upload_bulk","view_voucher","view_supplier_agent_list","view_invoice","bulk_upload","create_update_user_profile","create_sub_agent","view_agent_supplier_mapping","update_agent_cl","update_agent_threshold","download_voucher","update_agent_basic_info","supplier_credit_report","use_credit_wallet","settle_credit_note","add_new_supplier","view_purchase_and_debit_info","view_agent_sales_record","update_global_markup","download_invoice","update_agent_markup","finalize_booking","irn_update","rebooking_view","activate_inactivate_supplier","create_internal_users","add_amount_to_wallet","generate_quote","transfer_booking","review_booking","supplier_commission_report","s3_logs","agent_commission_report","account_sales_report","suspend_grn_user","create_amendment_ticket","cancel_booking","view_supplier_info","update_global_supplier_markup","update_hcn","view_agent_online_transactions","view_threshold_transactions","view_wallet_transactions","update_supplier_info","activate_inactivate_agent","use_credit_for_booking_creation","supplier_payment_report","agent_verification","edit_global_configuration","supplier_production_report","update_agent_max_cl","online_payment","create_new_booking","view_global_configuration","view_credit_transactions","view_booking_logs","edit_access_notifications","assign_temp_cl","edit_rate_configuration","view_booking","view_all_agency_sales","view_credit_note"],"user_type":"Agent","office_code":1000,"language_code":"en","used_cl":40610088.519999996,"distributed_by_parent_credit_limit":null,"parent_distributed_credit_limit":605.0,"parent_distributed_wb":461.0,"admin_name":null,"channel":30,"has_cl_tran":true,"sales_spoc_details_web":{"spoc":"sales head","spoc_phone":"+91 9696969696","spoc_email":"sales1@mailinator.com"},"ops_spoc_details_web":{"spoc":"Pragati sheel","spoc_phone":"9999999999","spoc_email":"op1@mailinator.com"},"sales_spoc_details_api":{"spoc":"Executive 1 Test","spoc_phone":"9843127887","spoc_email":"sales2@mailinator.com"},"ops_spoc_details_api":{"spoc":"SUNIL BISHT","spoc_phone":"7013616157","spoc_email":"ops2@mailinator.com"}}]
        // finalAgentProfileData.data.agentProfile.responseData=temp
        // upto here
        yield put(getAgentCreditLimitAction.FULLFILLED(finalAgentProfileData));
      } else {
        yield put(getAgentCreditLimitAction.FULLFILLED({}));
      }
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.promtsMessages
        ?.Wallet_Error_Message,
      closeIcon: true,
    });

    yield put(getAgentCreditLimitAction.REJECTED());
  }
}

function* queryMailTemplate(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    mailTemplateID: action?.payload.mailTemplateID,
  };
  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: MAIL_TEMPLATE,
      clientType: "MO",
      data: customHeaders,
    });
    yield put(getMailTemplateAction.FULLFILLED(data));
  } catch (error) {
    if (isGlobalApolloError(error)) return;

    UIMessage({
      messageText: "The current user is not authorized to access this resource.",
      closeIcon: true,
    });

    yield put(getMailTemplateAction.REJECTED());
  }
}

function* queryCurrencyConverter(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    searchValues: action?.payload?.searchValues,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_CURRENCY_CONVERSION_RATES_QUERY,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      data?.data?.currencyConversion?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      yield put(getCurrencyConversionRatesAction.FULLFILLED(data));
      action?.payload?.setLoader && action?.payload?.setLoader(false);
    } else {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      UIMessage({
        messageText: "Unable to fetch currency conversion values",
        closeIcon: true,
      });
      yield put(getCurrencyConversionRatesAction.REJECTED());
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: "Failed to fetch currency conversion values",
      closeIcon: true,
    });
    yield put(getCurrencyConversionRatesAction.REJECTED());
  }
}

function* queryBookingDraftByTWBidAction(action: any): any {
  if (action?.payload?.temp_id) {
    const temp_id = action?.payload?.temp_id;

    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
      },
      request: encryptAPIData(
        JSON.stringify({
          temp_id: temp_id || null,
          searchKey: action?.payload?.searchKey || null,
          hubSearchId: action?.payload?.hubSearchId || null,
        }),
      ),
    };

    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: BOOKINGDRAFT_BY_TWBID,
        clientType: "BE",
        data: customHeaders,
      });
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(bookingDraftByTWBidAction.FULLFILLED(data));
    } catch (error) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.failed_to_connect_please_check_network_connection,
        closeIcon: true,
      });
      yield put(bookingDraftByTWBidAction.REJECTED());
    }
  }
}

function* getthresholdLimitAdminAction(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    agent_id: action?.payload?.agent_id,
    bid: action?.payload?.bid,
    searchKey: action?.payload?.searchKey || "",
    hubSearchId: action?.payload?.hubSearchId || "",
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_THRESHOLD_LIMIT,
      clientType: "MO",
      data: customHeaders,
    });

    action?.payload?.setLoader(false);

    if (
      data?.data?.thresholdLimitAdmin?.successTypeCode.toLowerCase() ==
      "success" ||
      data?.data?.thresholdLimitAdmin?.successTypeCode.toLowerCase() == "fail"
    ) {
      // action?.payload?.setLoader(false);
      yield put(thresholdLimitAdminAction.FULLFILLED(data));
    } else {
      // action?.payload?.setLoader(false);
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(thresholdLimitAdminAction.REJECTED());
  }
}

function* addMailLog(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    mailVMInput: action.payload.mailVMInput,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_MAIL_LOG,
      data: customHeaders,
      clientType: "MO",
    });

    if (data?.data?.addMailLog?.messageCode === 201) {
      const message = {
        isOpen: true,
        mainHeader: "Success",
        subHeader: "",
        message: "Your email has successfully send",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
    }

    yield put(addMailLogAction.FULLFILLED(data));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(addMailLogAction.REJECTED());
  }
}

function* addUpdateBookingUploadCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    bookingUploadsVM: action?.payload?.bookingUploadsVM,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_UPDATE_BOOKING_UPLOAD,
      data: customHeaders,
      clientType: "BE",
    });

    if (data?.data?.addUpdateBookingUpload) {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      if (data?.data?.addUpdateBookingUpload?.messageCode === 200) {
        const message = {
          isOpen: true,
          mainHeader: "Success",
          subHeader: "",
          message: "Passport uploaded succesfully",
          subReq: false,
        };
        yield put(getNotificationMessage(message));
      } else {
        let message = "Passport not uploaded";
        if (data?.data?.addUpdateBookingUpload?.messageDescription) {
          message = data?.data?.addUpdateBookingUpload?.messageDescription;
        }
        const msg = {
          isOpen: true,
          mainHeader: message,
          subHeader: "",
          message: "",
          subReq: false,
        };
        yield put(getNotificationMessage(msg));
      }
    }
    yield put(addUpdateBookingUploadAction.FULLFILLED(data));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(addUpdateBookingUploadAction.REJECTED());
  }
}

function* bokkingdetailsbyiternaryId(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    itineraryId: action?.payload?.bookingVMInput?.iternaryid,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_BOOKINGDETAILS_BY_ITERNARYID,
      data: customHeaders,
      clientType: "MO",
    });
    if (
      data?.data?.bookingDetailsBasedOnItineraryId?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(
        bookingDetailsBasedOnItineraryId.FULLFILLED(
          data?.data?.bookingDetailsBasedOnItineraryId?.responseData,
        ),
      );
    } else {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(bookingDetailsBasedOnItineraryId.REJECTED());
  }
}

function* addUpdateBookingDraft(action: any): any {
  // console.log("bookingdraftpay", action.payload)
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    bookingVMInput: encryptAPIData(
      JSON.stringify(action?.payload?.bookingVMInput),
    ),
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_UPDATE_BOOKING_DRAFT,
      data: customHeaders,
      clientType: "BE",
    });
    if (
      data?.data?.addUpdateBookingDraft?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.setLoader?.(false);
      yield put(addUpdateBookingDraftAction.FULLFILLED(data));
    } else {
      action?.payload?.setLoader?.(false);
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader?.(false);
    !action?.payload?.bookingVMInput?.failure_reason &&
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.failed_to_connect_please_check_network_connection,
        closeIcon: true,
      });
    yield put(addUpdateBookingDraftAction.REJECTED());
  }
}

function* addAgentQuote(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    agentQuotesVM: action?.payload.agentQuotesVM,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_AGENTQUOTE,
      data: customHeaders,
      clientType: "MO",
    });

    if (data?.data?.addMailLog?.messageCode === 201) {
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.Quote_saved_successfully,
        closeIcon: true,
      });
    }

    yield put(addAgentQuoteAction.FULLFILLED(data));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(addAgentQuoteAction.REJECTED());
  }
}

function* callValidateDuplicateBooking(action: any): any {
  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: VALIDATE_DUPLICATE_BOOKING_QUERY,
      data: { duplicateBookingValidation: action?.payload?.request },
      clientType: "BE",
    });
    action?.payload?.setLoader?.(false);
    yield put(getValidateDuplicateBookingAction.FULLFILLED(data));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader?.(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(getValidateDuplicateBookingAction.REJECTED());
  }
}

function* configValueCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    config_key: action?.payload?.config_key,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: CONFIG_VALUE_QUERY,
      // data: action.payload,
      data: customHeaders,
      clientType: "MO",
    });

    if (data?.data?.configValue?.successTypeCode?.toLowerCase() == "success") {
      yield put(configValueAction.FULLFILLED(data?.data?.configValue));
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(configValueAction.REJECTED());
  }
}

// TW API
function* getAgentById(action: any): any {
  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_AGENTBY_ID,
      clientType: "MO",
      data: action?.payload,
    });
    yield put(getAgentByIdAction.FULLFILLED(data));
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.fetchAgentdetails
        }.`,
      closeIcon: true,
    });
    yield put(getAgentByIdAction.REJECTED());
  }
}

function* getBookingDetailsByBid(action: any): any {
  try {
    const token = getToken() ? getToken() : "";
    const customHeaders = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      bid: action?.payload,
    };
    const BookingDataByBid = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: BOOKING_DETAILS_BY_BID,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      BookingDataByBid?.data?.bookingDetailsByBid?.successTypeCode?.toLowerCase() ==
      "success" &&
      BookingDataByBid?.data?.bookingDetailsByBid?.responseData
    ) {
      yield put(getBookingDetailsByBidAction.FULLFILLED(BookingDataByBid));
    } else {
      yield put(getBookingDetailsByBidAction.FULLFILLED({}));
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: ` ${getLanguageCode(engLang, spanLang)?.wentwrong}, ${getLanguageCode(engLang, spanLang)?.fetchBookingdetails
        }.`,
      closeIcon: true,
    });
    yield put(getBookingDetailsByBidAction.REJECTED());
  }
}

function* addPGTransactionCall(action: any): any {
  const token = getToken();
  const customHeaders = {
    headers: {
      Authorization: token ? `Bearer ${token}` : `Bearer ${action?.payload?.accessToken}`,
    },
    paymentGatewayTransaction: action?.payload?.paymentGatewayTransaction,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_PG_TRANSACTION_CALL_WRAPPER,
      data: customHeaders,
      clientType: "BE",
    });

    if (data?.data?.addPGTransaction) {
      if (
        data?.data?.addPGTransaction?.successTypeCode?.toLowerCase() ==
        "success"
      ) {
        action?.payload?.setLoader && action?.payload?.setLoader(false);

        yield put(
          addPGTransactionAction.FULLFILLED(data?.data?.addPGTransaction),
        );
      } else {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        UIMessage({
          messageText: getLanguageCode(engLang, spanLang)
            ?.paymentMessage,
          closeIcon: true, onClose: () => action?.payload?.navigate && action?.payload?.navigate("/")
        })
        action?.payload?.onError?.();
        yield put(addPGTransactionAction.REJECTED());

      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    action?.payload?.onError?.();
    yield put(addPGTransactionAction.REJECTED());
  }
}

function* generateHash512ActionCall(action: any): any {
  const token = getToken();
  const customHeaders = {
    headers: {
      Authorization: token ? `Bearer ${getToken()}` : `Bearer ${action?.payload?.accessToken}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    text: action?.payload?.text,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GENERATE_HASH512_WRAPPER,
      data: customHeaders,
      clientType: "BE",
    });

    if (data?.data?.generateHash512) {
      if (
        data?.data?.generateHash512?.successTypeCode?.toLowerCase() == "success"
      ) {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        yield put(
          generateHash512Action.FULLFILLED(data?.data?.generateHash512),
        );
      } else {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        action?.payload?.onError?.();
        yield put(generateHash512Action.REJECTED());
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    action?.payload?.onError?.();
    yield put(generateHash512Action.REJECTED());
  }
}

function* getFeaturedHotels(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    featuredHotelsFilterVM: {
      current_date_flag: true
    },
  };

  if (action?.payload?.location_id) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: GENERATE_FEATURED_HOTELS_WRAPPER,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.featuredHotels?.messageDescription?.toLowerCase() ==
        "success" &&
        data?.data?.featuredHotels?.responseData
      ) {
        yield put(
          generateFeaturedHotelsAction.FULLFILLED({
            data: data?.data?.featuredHotels?.responseData,
            status: 200,
          }),
        );
      } else {
        yield put(generateFeaturedHotelsAction.REJECTED());
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      yield put(generateFeaturedHotelsAction.REJECTED());
    }
  }
}

function* getBookableThreshold(action: any): any {
  if (action?.payload?.agent_id) {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
      },
      request: encryptAPIData(JSON.stringify(action?.payload?.agent_id)),
    };

    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: BOOKABLE_THRESHOLD_LIMIT_DETAILS_QUERY,
        clientType: "MO",
        data: customHeaders,
      });

      if (
        data?.data?.bookableThresholdLimit?.messageDescription?.toLowerCase() ==
        "success"
      ) {
        action?.payload?.setLoading && action?.payload?.setLoading(false);
        yield put(
          bookableThresholdLimitAction.FULLFILLED({
            data: data?.data?.bookableThresholdLimit?.responseData,
            status: 200,
          }),
        );
      } else {
        action?.payload?.setLoading && action?.payload?.setLoading(false);
        yield put(bookableThresholdLimitAction.REJECTED());
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoading && action?.payload?.setLoading(false);
      yield put(bookableThresholdLimitAction.REJECTED());
    }
  }
}

export function* validatePaymentLink(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
      },
      data: action?.payload,
    };
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: VALIDATE_PAYMENT_LINK_MUTATION,
      clientType: "MO",
      data: customHeaders,
    });

    if (
      apiData?.data?.validatePaymentLink?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (apiData?.data?.validatePaymentLink?.responseData) {
        const decryptedResponse = decryptAPIData(apiData?.data?.validatePaymentLink?.responseData);
        const formattedData = {
          ...apiData.data.validatePaymentLink,
          responseData: decryptedResponse
        };
        yield put(
          validatePaymentLinkAction.FULLFILLED(formattedData),
        );
      }
      else {
        yield put(
          validatePaymentLinkAction.FULLFILLED(apiData?.data?.validatePaymentLink),
        );
      }
    }

  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.Payment_link_expired,
      closeIcon: true,
    });
    yield put(validatePaymentLinkAction.REJECTED());
  }
}

export function* getPaymentGatewayTransactionsQuery(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
      },
      searchValues: action?.payload?.searchValues,
    };
    const paymentGatewayTransactions = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_PAYMENT_GATEWAY_TRANSACTIONS_QUERY,
      clientType: "MO",
      data: customHeaders,
    });
    action?.payload?.isFinalize
      ? action?.payload?.setLoader?.(true)
      : action?.payload?.setLoader?.(false);
    if (
      paymentGatewayTransactions?.data?.paymentGatewayTransactions?.successTypeCode?.toLowerCase() ==
      "success" &&
      paymentGatewayTransactions?.data?.paymentGatewayTransactions?.responseData
    ) {
      if (
        paymentGatewayTransactions?.data?.paymentGatewayTransactions
          ?.responseData &&
        Array.isArray(
          paymentGatewayTransactions?.data?.paymentGatewayTransactions
            ?.responseData,
        ) &&
        paymentGatewayTransactions?.data?.paymentGatewayTransactions
          ?.responseData?.length > 0
      ) {
        yield put(
          paymentGatewayTransactionsAction.FULLFILLED({
            data: paymentGatewayTransactions?.data?.paymentGatewayTransactions
              ?.responseData,
            total_count:
              paymentGatewayTransactions?.data?.paymentGatewayTransactions
                ?.totalRecords,
          }),
        );
      } else {
        yield put(paymentGatewayTransactionsAction.FULLFILLED({}));
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader?.(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.Unable_to_fetch_wallet_transactions,
      closeIcon: true,
    });
    yield put(paymentGatewayTransactionsAction.REJECTED());
  }
}

function* getBookableCL(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    agent_id: action?.payload?.agent_id,
  };

  if (action?.payload?.agent_id) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: BOOKABLE_CL_DETAILS_QUERY,
        clientType: "MO",
        data: customHeaders,
      });

      if (
        data?.data?.bookableCl?.messageDescription?.toLowerCase() == "success"
      ) {
        action?.payload?.setLoading && action?.payload?.setLoading(false);
        yield put(
          bookableCLAction.FULLFILLED({
            data: data?.data?.bookableCl?.responseData,
            status: 200,
          }),
        );
      } else {
        action?.payload?.setLoading && action?.payload?.setLoading(false);
        yield put(bookableCLAction.REJECTED());
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoading && action?.payload?.setLoading(false);
      yield put(bookableCLAction.REJECTED());
    }
  }
}

function* getBookableWB(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    agent_id: action?.payload?.agent_id,
    walletType: action?.payload?.walletType, // selfwallet, parentwallet
  };

  if (action?.payload?.agent_id && action?.payload?.walletType) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: BOOKABLE_WB_DETAILS_QUERY,
        clientType: "MO",
        data: customHeaders,
      });

      if (
        data?.data?.bookableWB?.messageDescription?.toLowerCase() == "success"
      ) {
        action?.payload?.setLoading && action?.payload?.setLoading(false);
        yield put(
          bookableWBAction.FULLFILLED({
            data: data?.data?.bookableWB?.responseData,
            status: 200,
          }),
        );
      } else {
        action?.payload?.setLoading && action?.payload?.setLoading(false);
        yield put(bookableWBAction.REJECTED());
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoading && action?.payload?.setLoading(false);
      yield put(bookableWBAction.REJECTED());
    }
  }
}

function* getAgentAllWidgetsData(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    agent_id: action?.payload,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: AGENT_ALL_WIDGETS_DATA_QUERY,
      clientType: "MO",
      data: customHeaders,
    });
    if (
      data?.data?.agentAllWidgetsData?.successTypeCode?.toLowerCase() ==
      "success" &&
      data?.data?.agentAllWidgetsData?.responseData
    ) {
      yield put(
        getAgentAllWidgetsDataAction.FULLFILLED({
          data: data?.data?.agentAllWidgetsData?.responseData,
          status: 200,
        }),
      );
    } else {
      yield put(getAgentAllWidgetsDataAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getAgentAllWidgetsDataAction.REJECTED());
  }
}

export function* agentProfileByAgentIdQuery(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
      },
      agentId: action?.payload?.agentId,
    };

    const getAllActiveCreditLimitAgents = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: AGENT_PROFILE_BY_ID_QUERY,
      clientType: "MO",
      data: customHeaders,
    });

    if (
      getAllActiveCreditLimitAgents?.data?.agentProfileByAgentId?.successTypeCode?.toLowerCase() ==
      "success" &&
      getAllActiveCreditLimitAgents?.data?.agentProfileByAgentId?.responseData
    ) {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      if (
        getAllActiveCreditLimitAgents?.data?.agentProfileByAgentId
          ?.responseData &&
        Array.isArray(
          getAllActiveCreditLimitAgents?.data?.agentProfileByAgentId
            ?.responseData,
        ) &&
        getAllActiveCreditLimitAgents?.data?.agentProfileByAgentId?.responseData
          ?.length > 0
      ) {
        yield put(
          getAgentProfileByAgentIdAction.FULLFILLED({
            data: getAllActiveCreditLimitAgents?.data?.agentProfileByAgentId
              ?.responseData,
          }),
        );
      } else {
        yield put(getAgentProfileByAgentIdAction.FULLFILLED({}));
      }
    } else {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      UIMessage({
        messageText:
          getAllActiveCreditLimitAgents?.data?.agentProfileByAgentId
            ?.messageDescription,
        closeIcon: true,
      });
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.Unable_to_fetch_wallet_transactions,
      closeIcon: true,
    });
    yield put(getAgentProfileByAgentIdAction.REJECTED());
  }
}

function* validatePanCall(action: any): any {

  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: encryptAPIData(JSON.stringify(action?.payload?.requestPayload)),
    // input: JSON.stringify(action?.payload?.requestPayload),
    searchKey: action?.payload?.searchKey || "",
    hubSearchId: action?.payload?.hubSearchId || "",
    agentId: action?.payload?.agentId,
  };

  if (action?.payload?.requestPayload) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "mutation",
        dataQuery: VALIDATE_PANS_WRAPPER,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.postPans?.successTypeCode?.toLowerCase() === "success" &&
        data?.data?.postPans?.responseData
      ) {
        const decryptedData = JSON.parse(
          decryptAPIData(data?.data?.postPans?.responseData),
        );

        yield put(
          validatePANAction.FULLFILLED({
            data: decryptedData,
            status: 200,
          }),
        );
      } else {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        yield put(validatePANAction.REJECTED());
        yield put(
          validatePANAction.FULLFILLED({
            data: data?.data?.postPans,
          }),
        );
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      UIMessage({
        messageText: ` ${getLanguageCode(engLang, spanLang)?.promtsMessages?.unexcepctedError
          }.`,
        closeIcon: true,
      });
      yield put(validatePANAction.REJECTED());
    }
  }
}

function* itineraryIdByTempIdCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    temp_id: action?.payload?.temp_id || "",
  };

  if (action?.payload?.temp_id) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: GET_ITINERARY_ID_BY_TEMPID_QUERY,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.itineraryIdByTempId?.successTypeCode.toLowerCase() ===
        "success" &&
        data?.data?.itineraryIdByTempId?.responseData
      ) {
        yield put(
          queryItineraryIdByTempIdAction.FULLFILLED({
            data: data?.data?.itineraryIdByTempId?.responseData,
            status: 200,
          }),
        );
      } else {
        yield put(queryItineraryIdByTempIdAction.REJECTED({}));
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      yield put(queryItineraryIdByTempIdAction.REJECTED(error));
    }
  }
}

function* activityCancellationPolicyCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.input),
  };

  if (action?.payload?.input) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "mutation",
        dataQuery: ACTIVITY_CANCELLATION_POLICY_WRAPPER_MUTATION,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.activityCancellationPolicy?.successTypeCode.toLowerCase() ===
        "success" &&
        data?.data?.activityCancellationPolicy?.responseData
      ) {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        yield put(
          activityCancellationPolicyAction.FULLFILLED({
            data: data?.data?.activityCancellationPolicy?.responseData,
            status: 200,
          }),
        );
      } else {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        yield put(activityCancellationPolicyAction.REJECTED());
        UIMessage({
          messageText: ` ${getLanguageCode(engLang, spanLang)?.qouteNotsaved}.${getLanguageCode(engLang, spanLang)?.pleasetryAgain
            }`,
          closeIcon: true,
        });
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(activityCancellationPolicyAction.REJECTED());
      UIMessage({
        messageText: ` ${getLanguageCode(engLang, spanLang)?.qouteNotsaved}.${getLanguageCode(engLang, spanLang)?.pleasetryAgain
          }`,
        closeIcon: true,
      });
    }
  }
}

function* transferCancellationPolicyCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.input),
  };

  if (action?.payload?.input) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "mutation",
        dataQuery: TRANSFER_CANCELLATION_POLICY_WRAPPER_MUTATION,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.transferCancellationPolicy?.successTypeCode.toLowerCase() ===
        "success" &&
        data?.data?.transferCancellationPolicy?.responseData
      ) {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        yield put(
          transferCancellationPolicyAction.FULLFILLED({
            data: data?.data?.transferCancellationPolicy?.responseData,
            status: 200,
          }),
        );
      } else {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        yield put(transferCancellationPolicyAction.REJECTED());
        UIMessage({
          messageText: ` ${getLanguageCode(engLang, spanLang)?.qouteNotsaved}.${getLanguageCode(engLang, spanLang)?.pleasetryAgain
            }`,
          closeIcon: true,
        });
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(transferCancellationPolicyAction.REJECTED());
      UIMessage({
        messageText: ` ${getLanguageCode(engLang, spanLang)?.qouteNotsaved}.${getLanguageCode(engLang, spanLang)?.pleasetryAgain
          }`,
        closeIcon: true,
      });
    }
  }
}

function* updateValidationStatusCall(action: any): any {
  const token = getToken() || action?.payload?.accessToken;
  secureLocalStorage.removeItem("email_payment_token");
  const customHeaders = {
    headers: {
      Authorization: token && `Bearer ${token}`,
    },
    updatePGValidationStatus: action?.payload?.updatePGValidationStatus,
  };

  if (action?.payload?.updatePGValidationStatus) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "mutation",
        dataQuery: UPDATE_VALIDATION_STATUS_MUTATION,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.updateValidationStatus?.successTypeCode.toLowerCase() ===
        "success" &&
        data?.data?.updateValidationStatus?.responseData
      ) {
        yield put(
          updateValidationStatusAction.FULLFILLED({
            data: data?.data?.updateValidationStatus?.responseData,
            status: 200,
          }),
        );
      } else {
        yield put(updateValidationStatusAction.REJECTED());
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      yield put(updateValidationStatusAction.REJECTED());
    }
  }
}

function* abandonReasonsCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    hubSearchId: action?.payload?.hubSearchId || "",
    searchKey: action?.payload?.searchKey || "",
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_ABANDON_REASONS,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.abandonReasons?.successTypeCode.toLowerCase() === "success" &&
      data?.data?.abandonReasons?.responseData
    ) {
      yield put(
        abandonReasonsAction.FULLFILLED({
          data: data?.data?.abandonReasons?.responseData,
          status: 200,
        }),
      );
    } else {
      yield put(abandonReasonsAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(abandonReasonsAction.REJECTED());
  }
}

function* addUserSearchHistoryCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    userSearchHistory: action?.payload?.userSearchHistory,
    hubSearchId: action?.payload?.hubSearchId || "",
    searchKey: action?.payload?.searchKey || "",
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_USER_SEARCH_HISTORY_MUTATION,
      clientType: "MO",
      data: customHeaders,
    });

    if (
      data?.data?.addUserSearchHistory?.successTypeCode.toLowerCase() ===
      "success" &&
      data?.data?.addUserSearchHistory?.responseData
    ) {
      yield put(
        addUserSearchHistoryAction.FULLFILLED({
          data: data?.data?.addUserSearchHistory?.responseData,
          status: 200,
        }),
      );
    } else {
      yield put(addUserSearchHistoryAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(addUserSearchHistoryAction.REJECTED());
  }
}

function* userSearchHistoryFilterCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    userSearchHistoryFilterVM: action?.payload?.userSearchHistoryFilterVM,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_USER_SEARCH_HISTORY_QUERY,
      clientType: "MO",
      data: customHeaders,
    });

    if (
      data?.data?.userSearchHistory?.successTypeCode.toLowerCase() ===
      "success"
    ) {
      // Treat null/missing responseData as [] so empty history clears the UI
      // instead of REJECTED (which left the previous product's latest searches).
      yield put(
        getUserSearchHistoryAction.FULLFILLED({
          data: data?.data?.userSearchHistory?.responseData || [],
          status: 200,
        }),
      );
    } else {
      yield put(getUserSearchHistoryAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(getUserSearchHistoryAction.REJECTED());
  }
}

function* getDMCList(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action.payload?.request?.request,
    };

    const getDMCListings = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: DMC_QUERY_LIST,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader(false);
    if (getDMCListings?.data?.dmcList?.successTypeCode == "SUCCESS") {
      if (
        getDMCListings?.data?.dmcList?.responseData != null ||
        getDMCListings?.data?.dmcList?.responseData[0] != null
      ) {
        yield put(
          getDMCListAction.FULLFILLED(
            getDMCListings?.data?.dmcList?.responseData,
          ),
        );
      } else {
        yield put(getDMCListAction.FULLFILLED({}));
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.Unable_to_fetch_dmc_list,
      closeIcon: true,
    });
    yield put(getDMCListAction.REJECTED());
  }
}

function* getDMCCitiesList(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload,
    };

    const getDMCCitiesListings = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: DMC_CITIES_QUERY_LIST,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      getDMCCitiesListings?.data?.masterDmcCities?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      // action?.payload?.setLoader(false);
      if (
        getDMCCitiesListings?.data?.masterDmcCities?.responseData != null ||
        getDMCCitiesListings?.data?.masterDmcCities?.responseData[0] != null
      ) {
        yield put(
          getDMCCitiesAction.FULLFILLED(
            getDMCCitiesListings?.data?.masterDmcCities?.responseData,
          ),
        );
      } else {
        yield put(getDMCCitiesAction.FULLFILLED({}));
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.Unable_to_fetch_cities_list,
      closeIcon: true,
    });
    yield put(getDMCCitiesAction.REJECTED());
  }
}

function* getDMCTourTypesList(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload,
    };

    const getDMCTourTypesListings = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: DMC_TOURTYPES_QUERY_LIST,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      getDMCTourTypesListings?.data?.masterDmcTourType?.successTypeCode ==
      "SUCCESS"
    ) {
      // action?.payload?.setLoader(false);
      if (
        getDMCTourTypesListings?.data?.masterDmcTourType?.responseData !=
        null ||
        getDMCTourTypesListings?.data?.masterDmcTourType?.responseData[0] !=
        null
      ) {
        yield put(
          getDMCTourTypesAction.FULLFILLED(
            getDMCTourTypesListings?.data?.masterDmcTourType?.responseData,
          ),
        );
      } else {
        yield put(getDMCTourTypesAction.FULLFILLED({}));
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.Unable_to_fetch_tour_types_list,
      closeIcon: true,
    });
    yield put(getDMCTourTypesAction.REJECTED());
  }
}

function* getDMCPackagesList(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload,
    };
    const getDMCPackagesListings = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: DMC_FEATURED_PACKAGES_QUERY_LIST,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      getDMCPackagesListings?.data?.dmcListingMerge?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      action?.payload?.setDataLoading && action?.payload?.setDataLoading(false);
      if (
        getDMCPackagesListings?.data?.dmcListingMerge?.responseData != null ||
        getDMCPackagesListings?.data?.dmcListingMerge?.responseData[0] != null
      ) {
        yield put(
          getDMCPackagesAction.FULLFILLED(
            getDMCPackagesListings?.data?.dmcListingMerge?.responseData,
          ),
        );
      } else {
        yield put(getDMCPackagesAction.FULLFILLED({}));
      }
    } else {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      action?.payload?.setDataLoading && action?.payload?.setDataLoading(false);
      yield put(getDMCPackagesAction.REJECTED());
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    yield put(getDMCPackagesAction.REJECTED());
  }
}

function* getDMCPackDetailsList(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload,
    };

    const getDMCPackDetails = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: DMC_PACKAGES_DETAILS_QUERY_LIST,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      getDMCPackDetails?.data?.dmcPackageAndPrice?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      // action?.payload?.setLoader(false);
      if (
        getDMCPackDetails?.data?.dmcPackageAndPrice?.responseData != null ||
        getDMCPackDetails?.data?.dmcPackageAndPrice?.responseData[0] != null
      ) {
        yield put(
          getDMCPackDetailsAction.FULLFILLED(
            getDMCPackDetails?.data?.dmcPackageAndPrice?.responseData,
          ),
        );
      } else {
        yield put(getDMCPackDetailsAction.FULLFILLED({}));
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.Unable_to_fetch_featured_packages_list,
      closeIcon: true,
    });
    yield put(getDMCPackDetailsAction.REJECTED());
  }
}

function* queryZohoDependencyMapping(): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
    };
    const zohoDependecyMappingData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ZOHO_TICKET_DEPENDENCY_MAPPING,
      clientType: "MO",
      data: customHeaders,
    });
    yield put(
      setZohoTicketDependencyMappingAction.FULLFILLED(zohoDependecyMappingData),
    );
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(setZohoTicketDependencyMappingAction.REJECTED(String(error)));
  }
}

function* queryZohoLayoutRules(): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
    };
    const zohoLayoutRulesData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ZOHO_LAYOUT_RULES,
      clientType: "MO",
      data: customHeaders,
    });
    yield put(setZohoLayoutRulesAction.FULLFILLED(zohoLayoutRulesData));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(setZohoLayoutRulesAction.REJECTED(String(error)));
  }
}

function* zohoTicketCreation(action: any): any {
  try {
    const data = {
      input: action?.payload?.input,
      document: action?.payload?.document,
      filename: action?.payload?.filename,
    };
    const mutationResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ZOHO_CREATE_TICKET,
      data: data,
      clientType: "MO",
    });

    if (
      mutationResp?.data?.createTicket?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      yield put(setZohoTicketCreationAction.FULLFILLED(mutationResp));
      action?.payload?.setLoader && action?.payload?.setLoader(false);

      UIMessage({
        messageText:
          "Thanks for submitting the query. One of our team members will connect with you to fetch further details.",
        closeIcon: true,
      });
    } else {
      UIMessage({
        messageText: mutationResp?.data?.createTicket?.messageDescription,
        closeIcon: true,
      });
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      action?.payload?.setError && action?.payload?.setError(true);
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(setZohoTicketCreationAction.REJECTED());
  }
}

function* previewURLCall(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
      },
      url: action?.payload?.url,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: PREVIEW_URL_QUERY,
      data: customHeaders,
      clientType: "MO",
    });

    if (action?.payload?.setLoading) {
      action?.payload?.setLoading(false);
    }
    yield put(previewUrlAction.FULLFILLED(queryResp));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
      onClose: () => action?.payload?.setLoading(false),
    });
    yield put(previewUrlAction.REJECTED(String(error)));
  }
}

function* postPaymentGatewayCall(action: any): any {

  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: {
      billingLocation: action?.payload?.billingLocation,
      countryCode: action?.payload?.countryCode,
      currency: action?.payload?.currency,
      is_surcharge_enabled: action?.payload?.is_surcharge_enabled,
      is_surcharge_inclusive: action?.payload?.is_surcharge_inclusive,
      agentid: action?.payload?.agentid,
      userid: action?.payload?.userid,
      encdata: action?.payload?.encdata,
    },
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: POST_PAYMENT_GATEWAY_MUTATION,
      clientType: "MO",
      data: customHeaders,
    });

    if (
      data?.data?.postPaymentGateway?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (data?.data?.postPaymentGateway?.responseData) {
        yield put(
          postPaymentGatewayAction.FULLFILLED(
            data?.data?.postPaymentGateway?.responseData,
          ),
        );
      }

    }
    else if (data?.data?.postPaymentGateway?.successTypeCode?.toLowerCase() ==
      "failed" && data?.data?.postPaymentGateway?.messageCode == 2001) {
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.paymentMessage,
        closeIcon: true, onClose: () => action?.payload?.navigate && action?.payload?.navigate("/")

      })


    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });

    yield put(postPaymentGatewayAction.REJECTED());
  } finally {
    action?.payload?.setLoader?.(false);
  }
}

function* validatePGCurrencyCall(action: any): any {
  const token = getToken();
  const wrapperToken = getWrapperToken();
  const customHeaders = {
    headers: {
      Authorization: token ? `Bearer ${token}` : `Bearer ${action?.payload?.accessToken}`,
      "Wrapper-Token": token ? `Bearer ${wrapperToken}` : `Bearer ${action?.payload?.accessToken}`,
    },
    input: action?.payload?.input
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: VALIDATE_PG_CURRENCY_QUERY,
      clientType: "MO",
      data: customHeaders,
    });

    if (
      data?.data?.validatePGCurrency?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (data?.data?.validatePGCurrency?.responseData) {
        if (action?.payload?.setValidatePGCurrencyData) {
          action?.payload?.setValidatePGCurrencyData(
            JSON.parse(decryptAPIData(data?.data?.validatePGCurrency?.responseData))
          );
        }
      }
    } else {
      if (action?.payload?.setValidatePGCurrencyData) {
        action?.payload?.setValidatePGCurrencyData({});
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    if (action?.payload?.setValidatePGCurrencyData) {
      action?.payload?.setValidatePGCurrencyData({});
    }
  }
}

function* voucherViewDetailsCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    bid: action?.payload?.bid,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: VOUCHER_VIEW_DETAILS_QUERY,
      clientType: "BE",
      data: customHeaders,
    });

    action?.payload?.setLoading?.(false);
    if (
      data?.data?.voucherViewDetails?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (data?.data?.voucherViewDetails?.responseData) {
        yield put(
          voucherViewDetailsAction.FULLFILLED(
            data?.data?.voucherViewDetails?.responseData,
          ),
        );
        action?.payload?.handleSuccess?.(data?.data?.voucherViewDetails?.responseData,);
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });

    yield put(voucherViewDetailsAction.REJECTED());
  }
}

function* voucherViewEurailTicketDetailsCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    bid: action?.payload?.bid,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: VOUCHER_VIEW_EURAIL_DETAILS_QUERY,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoading?.(false);
    if (
      data?.data?.eurailVoucherViewDetails?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (data?.data?.eurailVoucherViewDetails?.responseData) {
        yield put(
          voucherViewEurailDetailsAction.FULLFILLED(
            data?.data?.eurailVoucherViewDetails?.responseData,
          ),
        );
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });

    yield put(voucherViewEurailDetailsAction.REJECTED());
  }
}

function* VoucherViewTransferDetailsCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    bid: action?.payload?.bid,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: VOUCHER_VIEW_TRANSFER_DETAILS_QUERY,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.voucherViewTransferDetails?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (data?.data?.voucherViewTransferDetails?.responseData) {
        yield put(
          voucherViewTransferDetailsAction.FULLFILLED(
            data?.data?.voucherViewTransferDetails?.responseData,
          ),
        );
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(voucherViewTransferDetailsAction.REJECTED());
  }
}

function* VoucherViewActivityDetailsCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    bid: action?.payload?.bid,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: VOUCHER_VIEW_ACTIVITY_DETAILS_QUERY,
      clientType: "BE",
      data: customHeaders,
    });


    if (
      data?.data?.voucherViewActivityDetails?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (data?.data?.voucherViewActivityDetails?.responseData) {
        yield put(
          voucherViewActivityDetailsAction.FULLFILLED(
            data?.data?.voucherViewActivityDetails?.responseData,
          ),
        );
        action?.payload?.handleSuccess?.(data?.data?.voucherViewActivityDetails?.responseData,);
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(voucherViewActivityDetailsAction.REJECTED());
  }
}

function* biDfromTempIdCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    temp_id: action?.payload?.temp_id,
  };

  if (action?.payload?.temp_id) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: BID_FROM_TEMP_ID_QUERY,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.biDfromTempId?.successTypeCode?.toLowerCase() == "success"
      ) {
        if (data?.data?.biDfromTempId?.responseData) {
          action?.payload?.setLoader && action?.payload?.setLoader(false);
          yield put(
            biDfromTempIdAction.FULLFILLED(
              data?.data?.biDfromTempId?.responseData,
            ),
          );
        } else {
          action?.payload?.setLoader && action?.payload?.setLoader(false);
          yield put(biDfromTempIdAction.REJECTED());
        }
      } else {
        action?.payload?.setLoader && action?.payload?.setLoader(false);
        yield put(biDfromTempIdAction.REJECTED());
      }
    } catch (error) {
      if (isGlobalApolloError(error)) return;
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.failed_to_connect_please_check_network_connection,
        closeIcon: true,
      });
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(biDfromTempIdAction.REJECTED());
    }
  }
}

function* updatePGInvoiceNumberCall(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    updatePGInvoiceNumber: {
      bid: action?.payload?.bid,
      temp_bid: action?.payload?.temp_id,
    },
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: UPDATE_PG_INVOICE_NUMBER_QUERY,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.biDfromTempId?.successTypeCode?.toLowerCase() == "success"
    ) {
      if (data?.data?.biDfromTempId?.responseData) {
        yield put(
          updatePGInvoiceNumberAction.FULLFILLED(
            data?.data?.biDfromTempId?.responseData,
          ),
        );
      }
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(updatePGInvoiceNumberAction.REJECTED());
  }
}

// function* addBookingMailDataCall(action: any): any {
//   if (action?.payload?.bid) {
//     const customHeaders = {
//       headers: {
//         Authorization: getToken() && `Bearer ${getToken()}`,
//       },
//       bookingMailDataVM: {
//         bid:
//           typeof action?.payload?.bid == "string" ? action?.payload?.bid : null,
//         booking_status: action?.payload?.booking_status,
//         type_of_booking: action?.payload?.type_of_booking,
//         created_by: null,
//         created_on: null,
//         id: null,
//         mail_sent_status: null,
//       },
//     };

//     try {
//       const data = yield call(newRequest, {
//         callType: "apollo",
//         callMethod: "mutation",
//         dataQuery: ADD_BOOKING_MAIL_DATA_MUTATION,
//         clientType: "BE",
//         data: customHeaders,
//       });

//       if (
//         data?.data?.addBookingMailData?.successTypeCode?.toLowerCase() == "success"
//       ) {
//         if (data?.data?.addBookingMailData?.responseData) {
//           yield put(
//             addBookingMailDataAction.FULLFILLED(
//               data?.data?.addBookingMailData?.responseData
//             )
//           );
//         }
//       }
//     } catch (error) {
//       customNotify({
//         message: "Failed to connect",
//         description: "Please check Network connection",
//         type: "error",
//       });
//       // const msg = get(error, "data.error.error", "Failed to get data");
//       yield put(addBookingMailDataAction.REJECTED());
//     }
//   }
// }

function* getLoginURL(action: any): any {
  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: action?.payload?.isLocal
        ? GENERATE_LOGINURL
        : GENERATE_NONLOCAL_LOGINURL,
      data: {
        isLocal: action?.payload?.isLocal,
      },
      clientType: "",
    });
    action?.payload?.setLoading(false);
    if (data?.data?.loginUrl) {
      yield put(
        generateLoginUrlAction.FULLFILLED({
          data: data?.data,
          status: 200,
        }),
      );
    } else {
      yield put(generateLoginUrlAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoading(false);
    yield put(generateLoginUrlAction.REJECTED());
  }
}

function* checkPanExistForAgentCall(action: any): any {
  if (action?.payload?.pan) {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
      },
      pan: action?.payload?.pan,
      agent_id: action?.payload?.agent_id,
    };

    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "query",
        dataQuery: CHECK_PAN_EXISTS_FOR_AGENT_DATA_QUERY,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.checkPanExistForagent?.successTypeCode?.toLowerCase() ==
        "success"
      ) {
        yield put(
          checkPanExistForAgentAction.FULLFILLED(
            data?.data?.checkPanExistForagent,
          ),
        );
      }
    } catch (error) {
      if (isGlobalApolloError(error)) return;
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.failed_to_connect_please_check_network_connection,
        closeIcon: true,
      });
      yield put(checkPanExistForAgentAction.REJECTED());
    }
  }
}

function* BillingInvoiceSaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload?.requestPayload?.request,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GRN_INVOICES_LIST,
      clientType: "MO",
      data: customHeaders,
    });
    action?.payload?.setLoading(false);
    if (queryResp?.data?.grnInvoice?.successTypeCode == "SUCCESS") {
      yield put(
        queryBillingListAction.FULLFILLED(
          queryResp?.data?.grnInvoice?.responseData,
        ),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
      onClose: () => action?.payload?.setLoading(false),
    });
    yield put(queryBillingListAction.REJECTED(String(error)));
  }
}
function* PerformaInvoiceSaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload?.request,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery:
        action?.payload?.type === "hotel"
          ? HOTEL_PROFORMA_INVOICE_QUERY
          : action?.payload?.type === "activity"
            ? ACTIVITY_PROFORMA_INVOICE_QUERY
            : action?.payload?.type === "transfer"
              ? TRANSFER_PROFORMA_INVOICE_QUERY
              : EURAIL_PROFORMA_INVOICE_QUERY,
      clientType: "MO",
      data: customHeaders,
    });

    action?.payload?.setLoading(true);
    const module =
      action?.payload?.type === "hotel"
        ? "proformaInvoiceHotelDetails"
        : action?.payload?.type === "activity"
          ? "proformaInvoiceActivityDetails"
          : action?.payload?.type === "transfer"
            ? "proformaInvoiceTransferDetails"
            : "proformaInvoiceEurailDetails";
    if (queryResp?.data[module]?.successTypeCode == "SUCCESS") {
      action?.payload?.openModalProductWiseProforma?.(
        queryResp?.data[module]?.responseData,
      );
      yield put(
        queryProformaAction.FULLFILLED(queryResp?.data[module]?.responseData),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
      onClose: () => action?.payload?.setLoading(false),
    });
    yield put(queryProformaAction.REJECTED(String(error)));
  }
}

function* agentInfoFinalizeTransfer(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    searchValues: action?.payload,
  };

  try {
    const agentInfo = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: AGENT_INFO_FINALIZE_TRANSFER_QUERY,
      data: customHeaders,
      clientType: "MO",
    });
    if (
      agentInfo?.data?.agentInfoForFinalizeTransfer?.successTypeCode?.toLowerCase() ===
      "success"
    ) {
      yield put(
        agentInfoFinalizeTransferAction.FULLFILLED(
          agentInfo?.data?.agentInfoForFinalizeTransfer?.responseData,
        ),
      );
    } else {
      yield put(agentInfoFinalizeTransferAction.REJECTED());
      UIMessage({
        messageText:
          agentInfo?.data?.agentInfoForFinalizeTransfer?.messageDescription,
        closeIcon: true,
      });
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(agentInfoFinalizeTransferAction.REJECTED());
  }
}

function* priceCalculateOcPc(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.input),
  };

  try {
    const transferFinalizeData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: PRICE_CALCULATE_OC_PC_QUERY,
      data: customHeaders,
      clientType: "MO",
    });
    action?.payload?.setLoading?.(false);
    action?.payload?.setRecalcLoading?.(false);
    if (
      transferFinalizeData?.data?.priceCalculateOcPc?.successTypeCode?.toLowerCase() ===
      "success" &&
      transferFinalizeData?.data?.priceCalculateOcPc?.responseData?.data
    ) {
      if (action.payload?.bookingTableTrigger) {
        action.payload?.bookingTableTrigger();
      }
      yield put(
        priceCalculateOcPcAction.FULLFILLED(
          transferFinalizeData?.data?.priceCalculateOcPc?.responseData,
        ),
      );
    } else if (
      !transferFinalizeData?.data?.priceCalculateOcPc?.responseData?.data
    ) {
      if (action?.payload?.setApiValidationError) {
        action?.payload?.setApiValidationError({
          status: true,
          msg: transferFinalizeData?.data?.priceCalculateOcPc?.responseData
            ?.error,
        });
      }
      yield put(priceCalculateOcPcAction.REJECTED());
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoading?.(false);
    action?.payload?.setRecalcLoading?.(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(priceCalculateOcPcAction.REJECTED());
  }
}

function* postPriceCalculate(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.input),
  };

  try {
    const mutationResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: POST_PRICE_CALCULATE_MUTATION,
      data: customHeaders,
      clientType: "MO",
    });
    action?.payload?.setLoading?.(false);
    action?.payload?.setRecalcLoading?.(false);
    if (
      mutationResp?.data?.postPriceCalculate?.successTypeCode?.toLowerCase() ===
      "success" &&
      mutationResp?.data?.postPriceCalculate?.responseData?.data
    ) {
      if (action.payload?.bookingTableTrigger) {
        action.payload?.bookingTableTrigger();
      }
      yield put(
        postPriceCalculateAction.FULLFILLED(
          mutationResp?.data?.postPriceCalculate?.responseData,
        ),
      );
    } else if (!mutationResp?.data?.postPriceCalculate?.responseData?.data) {
      UIMessage({
        messageText:
          mutationResp?.data?.postPriceCalculate?.responseData?.error,
        closeIcon: true,
      });
      yield put(postPriceCalculateAction.REJECTED());
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoading?.(false);
    action?.payload?.setRecalcLoading?.(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(postPriceCalculateAction.REJECTED());
  }
}

function* getAgentsByCurrency(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    currency: action?.payload,
  };

  try {
    const agentsData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_AGENTS_BY_CURRENCY_QUERY,
      data: customHeaders,
      clientType: "MO",
    });
    if (
      agentsData?.data?.agentsByCurrency?.successTypeCode?.toLowerCase() ===
      "success"
    ) {
      yield put(
        getAgentsByCurrencyAction.FULLFILLED(
          agentsData?.data?.agentsByCurrency?.responseData,
        ),
      );
    } else {
      yield put(getAgentsByCurrencyAction.REJECTED());
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(getAgentsByCurrencyAction.REJECTED());
  }
}

function* agentsCurrencyandInvoiceEntitySaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      currency: action?.payload?.currency,
      invoicing_entity_id: action?.payload?.invoicing_entity_id,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: AGENTS_BY_CURRENCY_AND_INVOICEENTITY_QUERY,
      data: customHeaders,
      clientType: "MO",
    });
    if (
      queryResp?.data?.agentsByCurrencyAndInvoiceEntity?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      const queryRespData =
        queryResp?.data?.agentsByCurrencyAndInvoiceEntity?.responseData;
      yield put(
        agentsByCurrencyandInvoiceEntityAction.FULLFILLED(queryRespData),
      );
    } else {
      yield put(agentsByCurrencyandInvoiceEntityAction.REJECTED());
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: "Failed to Connect, Please Check Network Connection",
      closeIcon: true,
    });
    yield put(agentsByCurrencyandInvoiceEntityAction.REJECTED());
  }
}

function* queryBookingsList(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    searchValues: action?.payload?.requestPayload?.searchValues,
  };

  try {
    const bookingsData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_BOOKINGS_LIST_BY_GRN,
      data: customHeaders,
      clientType: "MO",
    });
    action?.payload?.setLoading?.(false);
    yield put(queryBookingsListAction.FULLFILLED(bookingsData));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoading?.(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(queryBookingsListAction.REJECTED(String(error)));
  }
}

function* addTransferToAgentCall(action: any): any {
  if (action?.payload?.bookingMailDataVM) {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      transferToAgentBooking: action?.payload?.bookingMailDataVM,
    };
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "mutation",
        dataQuery: ADD_TRANSFER_TO_AGENT_MUTATION,
        clientType: "MO",
        data: customHeaders,
      });
      action?.payload?.setLoading?.(false);
      if (
        data?.data?.addTransferToAgent?.successTypeCode?.toLowerCase() ===
        "failed"
      ) {
        yield put(addTransferToAgentAction.REJECTED());
        UIMessage({
          messageText: data?.data?.addTransferToAgent?.messageDescription,
          closeIcon: true,
        });
      } else if (data?.data?.addTransferToAgent?.responseData?.bid) {
        if (data?.data?.addTransferToAgent?.responseData) {
          yield put(
            addTransferToAgentAction.FULLFILLED(
              data?.data?.addTransferToAgent?.responseData,
            ),
          );
          UIMessage({
            messageText:
              data?.data?.addTransferToAgent?.messageDescription ||
              "Transferred Successfully.",
            closeIcon: true,
          });
        }
      }
    } catch (error) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoading?.(false);
      yield put(addTransferToAgentAction.REJECTED());
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.failed_to_connect_please_check_network_connection,
        closeIcon: true,
      });
    }
  }
}

function* queryAddFinalizeBookings(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    request: action?.payload?.request,
  };

  try {
    const finalizeData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_FINALIZE_BOOKINGS_QUERY,
      data: customHeaders,
      clientType: "MO",
    });
    action?.payload?.setLoading?.(false);
    if (
      finalizeData?.data?.addFinalizedBookings?.successTypeCode?.toLowerCase() ===
      "success"
    ) {
      action?.payload?.closeModal?.();
      yield put(
        queryAddFinalizeBookingsAction.FULLFILLED(
          finalizeData?.data?.addFinalizedBookings,
        ),
      );
      UIMessage({
        messageText:
          finalizeData?.data?.addFinalizedBookings?.messageDescription,
        closeIcon: true,
        onClose: () => {
          if (action?.payload?.redirectTo) {
            action?.payload?.removeCookies?.();
            action?.payload?.redirectTo?.();
          }
        },
      });
    } else {
      UIMessage({
        messageText:
          finalizeData?.data?.addFinalizedBookings?.messageDescription,
        closeIcon: true,
        onClose: () => {
          if (action?.payload?.redirectTo) {
            action?.payload?.removeCookies?.();
            action?.payload?.redirectTo?.();
          }
        },
      });
      yield put(
        queryAddFinalizeBookingsAction.FULLFILLED(
          finalizeData?.data?.addFinalizedBookings,
        ),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoading?.(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)
        ?.failed_to_connect_please_check_network_connection,
      closeIcon: true,
    });
    yield put(queryAddFinalizeBookingsAction.REJECTED());
  }
}

function* agentInvoiceSaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload?.requestPayload?.request,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: AGENT_INVOICE_QUERY,
      clientType: "MO",
      data: customHeaders,
    });

    if (
      queryResp?.data?.agentInvoice?.successTypeCode?.toLowerCase() ===
      "success" &&
      !action?.payload?.setAllExcelExportBookings
    ) {
      yield put(
        agentInvoiceAction.FULLFILLED(
          queryResp?.data?.agentInvoice?.responseData,
        ),
      );
      action?.payload?.setLoading && action?.payload?.setLoading(false);
    } else if (
      queryResp?.data?.agentInvoice?.successTypeCode == "SUCCESS" &&
      action?.payload?.setAllExcelExportBookings
    ) {
      action?.payload?.setAllExcelExportBookings(
        queryResp?.data?.agentInvoice?.responseData,
      );
      action?.payload?.setLoading && action?.payload?.setLoading(false);
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoading && action?.payload?.setLoading(false);
    yield put(agentInvoiceAction.REJECTED(String(error)));
  }
}

function* addDuplicateBookingMailDataStart(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    addDuplicateBookingMailData: action?.payload?.addDuplicateBookingMailData,
  };

  if (action?.payload?.addDuplicateBookingMailData) {
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "mutation",
        dataQuery: ADD_DUPLICATE_BOOKING_MAIL_DATA_QUERY,
        clientType: "BE",
        data: customHeaders,
      });

      if (
        data?.data?.addDuplicateBookingMailData?.successTypeCode.toLowerCase() ===
        "success" &&
        data?.data?.addDuplicateBookingMailData?.responseData
      ) {
        yield put(
          addDuplicateBookingMailDataAction.FULLFILLED({
            data: data?.data?.addDuplicateBookingMailData?.responseData,
            status: 200,
          }),
        );
      } else {
        yield put(addDuplicateBookingMailDataAction.REJECTED({}));
      }
    } catch (error: any) {
      if (isGlobalApolloError(error)) return;
      yield put(addDuplicateBookingMailDataAction.REJECTED(error));
    }
  }
}

function* addFinalizeAndTransferForTransferProductAgent(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    request: action?.payload?.request,
  };

  try {
    const finalizeData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_FINALIZED_BOOKINGS_TRANSFER_AGENT,
      data: customHeaders,
      clientType: "MO",
    });
    action?.payload?.setLoading?.(false);
    if (
      finalizeData?.data?.addFinalizedBookingsForTransferProduct?.successTypeCode?.toLowerCase() ===
      "success"
    ) {
      action?.payload?.closeModal?.();
      yield put(
        finalizedBookingsTransferAgentAction.FULLFILLED(
          finalizeData?.data?.addFinalizedBookingsForTransferProduct,
        ),
      );
      UIMessage({
        messageText:
          finalizeData?.data?.addFinalizedBookingsForTransferProduct
            ?.messageDescription,
        closeIcon: true,
        onClose: () => {
          if (action?.payload?.redirectTo) {
            action?.payload?.removeCookies?.();
            action?.payload?.redirectTo?.();
          }
        },
      });
    } else {
      UIMessage({
        messageText:
          finalizeData?.data?.addFinalizedBookingsForTransferProduct
            ?.messageDescription,
        closeIcon: true,
        onClose: () => {
          if (action?.payload?.redirectTo) {
            action?.payload?.removeCookies?.();
            action?.payload?.redirectTo?.();
          }
        },
      });
      yield put(
        finalizedBookingsTransferAgentAction.FULLFILLED(
          finalizeData?.data?.addFinalizedBookingsForTransferProduct,
        ),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoading?.(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.network_failed_error,
      closeIcon: true,
    });
    yield put(finalizedBookingsTransferAgentAction.REJECTED());
  }
}

function* addFinalizeAndTransferForTransferProductAdmin(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    request: action?.payload?.request,
  };

  try {
    const finalizeData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_FINALIZE_BOOKINGS_TRANSFER_ADMIN,
      data: customHeaders,
      clientType: "MO",
    });
    action?.payload?.setLoading?.(false);
    if (
      finalizeData?.data?.addFinalizeAndTransferForTransferProduct?.successTypeCode?.toLowerCase() ===
      "success"
    ) {
      action?.payload?.closeModal?.();
      yield put(
        finalizeBookingsTransferAdminAction.FULLFILLED(
          finalizeData?.data?.addFinalizeAndTransferForTransferProduct,
        ),
      );
      UIMessage({
        messageText:
          finalizeData?.data?.addFinalizeAndTransferForTransferProduct
            ?.messageDescription,
        closeIcon: true,
        onClose: () => {
          if (action?.payload?.redirectTo) {
            action?.payload?.removeCookies?.();
            action?.payload?.redirectTo?.();
          }
        },
      });
    } else {
      UIMessage({
        messageText:
          finalizeData?.data?.addFinalizeAndTransferForTransferProduct
            ?.messageDescription,
        closeIcon: true,
        onClose: () => {
          if (action?.payload?.redirectTo) {
            action?.payload?.removeCookies?.();
            action?.payload?.redirectTo?.();
          }
        },
      });
      yield put(
        finalizeBookingsTransferAdminAction.FULLFILLED(
          finalizeData?.data?.addFinalizeAndTransferForTransferProduct,
        ),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoading?.(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.network_failed_error,
      closeIcon: true,
    });
    yield put(finalizeBookingsTransferAdminAction.REJECTED());
  }
}

function* addTransferToAgentTransferCall(action: any): any {
  if (action?.payload?.bookingMailDataVM) {
    const customHeaders = {
      headers: {
        Authorization: getToken() && `Bearer ${getToken()}`,
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      transferToAgentBooking: action?.payload?.bookingMailDataVM,
    };
    try {
      const data = yield call(newRequest, {
        callType: "apollo",
        callMethod: "mutation",
        dataQuery: ADD_TRANSFER_TO_AGENT_TRASFER_MUTATION,
        clientType: "MO",
        data: customHeaders,
      });
      action?.payload?.setLoading?.(false);
      if (
        data?.data?.addTransferToAgentForTransferProduct?.successTypeCode?.toLowerCase() ===
        "failed"
      ) {
        yield put(addTransferToAgentTransferAction.REJECTED());
        UIMessage({
          messageText:
            data?.data?.addTransferToAgentForTransferProduct
              ?.messageDescription,
          closeIcon: true,
        });
      } else if (
        data?.data?.addTransferToAgentForTransferProduct?.responseData?.bid
      ) {
        if (data?.data?.addTransferToAgentForTransferProduct?.responseData) {
          yield put(
            addTransferToAgentTransferAction.FULLFILLED(
              data?.data?.addTransferToAgentForTransferProduct?.responseData,
            ),
          );
          UIMessage({
            messageText:
              data?.data?.addTransferToAgentForTransferProduct
                ?.messageDescription || "Transferred Successfully.",
            closeIcon: true,
          });
        }
      }
    } catch (error) {
      if (isGlobalApolloError(error)) return;
      action?.payload?.setLoading?.(false);
      yield put(addTransferToAgentTransferAction.REJECTED());
      UIMessage({
        messageText: getLanguageCode(engLang, spanLang)
          ?.failed_to_connect_please_check_network_connection,
        closeIcon: true,
      });
    }
  }
}

function* getAccessNotificationsPermissions(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    agent_id: action?.payload,
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ACCESS_NOTIFICATIONS_QUERY,
      data: customHeaders,
      clientType: "MO",
    });
    if (
      apiData?.data?.bdAcessandNotifications?.successTypeCode?.toLowerCase() ===
      "success" &&
      apiData?.data?.bdAcessandNotifications?.responseData
    ) {
      yield put(
        accessNotificationsPermissionsAction.FULLFILLED(
          apiData?.data?.bdAcessandNotifications?.responseData,
        ),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    yield put(accessNotificationsPermissionsAction.REJECTED());
  }
}

function* hotelInvoiceSaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload?.request,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: HOTEL_INVOICE_QUERY,
      clientType: "MO",
      data: customHeaders,
    });
    action?.payload?.setLoading?.(false);
    if (queryResp?.data?.invoiceHotelDetails?.successTypeCode == "SUCCESS") {
      action?.payload?.openModalProductWise?.(
        queryResp?.data?.invoiceHotelDetails?.responseData,
      );
      yield put(
        getHotelInvoiceAction.FULLFILLED(
          queryResp?.data?.invoiceHotelDetails?.responseData,
        ),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    customNotify({
      message: "Failed to connect",
      description: "Please check Network connection",
      type: "error",
    });
    yield put(getHotelInvoiceAction.REJECTED(String(error)));
  }
}

function* eurailInvoiceSaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload?.request,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: EURAIL_INVOICE_QUERY,
      clientType: "MO",
      data: customHeaders,
    });
    action?.payload?.setLoading?.(false);
    if (queryResp?.data?.invoiceEurailDetails?.successTypeCode == "SUCCESS") {
      action?.payload?.openModalProductWise?.(
        queryResp?.data?.invoiceEurailDetails?.responseData,
      );
      yield put(
        getEurailInvoiceAction.FULLFILLED(
          queryResp?.data?.invoiceEurailDetails?.responseData,
        ),
      );
    } else {
      action?.payload?.openModalProductWise?.(null);
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    customNotify({
      message: "Failed to connect",
      description: "Please check Network connection",
      type: "error",
    });
    yield put(getEurailInvoiceAction.REJECTED(String(error)));
  }
}

function* activityInvoiceSaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload?.request,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ACTIVITY_INVOICE_QUERY,
      clientType: "MO",
      data: customHeaders,
    });
    action?.payload?.setLoading?.(false);
    if (queryResp?.data?.invoiceActivityDetails?.successTypeCode == "SUCCESS") {
      action?.payload?.openModalProductWise?.(
        queryResp?.data?.invoiceActivityDetails?.responseData,
      );
      yield put(
        getActivityInvoiceAction.FULLFILLED(
          queryResp?.data?.invoiceActivityDetails?.responseData,
        ),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    customNotify({
      message: "Failed to connect",
      description: "Please check Network connection",
      type: "error",
    });
    yield put(getActivityInvoiceAction.REJECTED(String(error)));
  }
}

function* transfersInvoiceSaga(action: any): any {
  try {
    const customHeaders = {
      headers: {
        Authorization: getToken() ? `Bearer ${getToken()}` : "",
        "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
      },
      request: action?.payload?.request,
    };
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: TRANSFERS_INVOICE_QUERY,
      clientType: "MO",
      data: customHeaders,
    });
    action?.payload?.setLoading?.(false);
    if (queryResp?.data?.invoiceTransferDetails?.successTypeCode == "SUCCESS") {
      action?.payload?.openModalProductWise?.(
        queryResp?.data?.invoiceTransferDetails?.responseData,
      );
      yield put(
        getTransfersInvoiceAction.FULLFILLED(
          queryResp?.data?.invoiceTransferDetails?.responseData,
        ),
      );
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    customNotify({
      message: "Failed to connect",
      description: "Please check Network connection",
      type: "error",
    });
    yield put(getTransfersInvoiceAction.REJECTED(String(error)));
  }
}

function* requestFailureReasonStatusFunc(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    request: action?.payload?.request,
  };
  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: REQUEST_FAILURE_REASON_STATUS_MUTATION,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader?.(false);
    if (
      data?.data?.updatebookingdraftStatus?.successTypeCode?.toLowerCase() ===
      "success" &&
      data?.data?.updatebookingdraftStatus?.responseData
    ) {
      yield put(
        requestFailureReasonStatusAction.FULLFILLED(
          data?.data?.addDuplicateBookingMailData?.responseData,
        ),
      );
      action?.payload?.abandonNavFunc?.();
    } else {
      yield put(requestFailureReasonStatusAction.REJECTED({}));
      UIMessage({
        messageText: data?.data?.addUpdateBookingDraft?.messageDescription,
        closeIcon: true,
        onClose: () => action?.payload?.abandonNavFunc?.(),
      });
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader?.(false);
    UIMessage({
      messageText: `${getLanguageCode(engLang, spanLang)?.timeoutmessage}.`,
      closeIcon: true,
      onClose: () => action?.payload?.onClose?.(),
    });
    yield put(requestFailureReasonStatusAction.REJECTED(error));
  }
}

function* sendVoucherMailSaga(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
    },
    request: action?.payload?.request,
  };
  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: SEND_VOUCHER_MAIL,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setOpenModal?.(false);
    action?.payload?.setSendEmailBTN?.(false);
    if (
      data?.data?.sendVoucherMail?.successTypeCode?.toLowerCase() ===
      "success" &&
      data?.data?.sendVoucherMail?.responseData
    ) {

      const message = {
        isOpen: true,
        mainHeader:
          data?.data?.sendVoucherMail?.messageDescription,
        subHeader: "",
        message: "",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(
        sendVoucherMailAction.FULLFILLED(
          data?.data?.sendVoucherMail?.responseData
        )
      );
    } else {
      yield put(sendVoucherMailAction.REJECTED({}));
      UIMessage({
        messageText: data?.data?.sendVoucherMail?.messageDescription,
        closeIcon: true,
      });
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setOpenModal?.(false);
    UIMessage({
      messageText: `${getLanguageCode(engLang, spanLang)?.timeoutmessage}.`,
      closeIcon: true,
    });
    yield put(sendVoucherMailAction.REJECTED(error));
  }
}

export function* watcherDashboard() {
  yield takeLatest(GET_SEARCH_LOC.STARTED, getSearchLoc);
  yield takeLatest(
    GENERATE_INVOICE_PDF_ACTIONTYPE.STARTED,
    generateInvoicePdfSaga,
  );
  yield takeLatest(GET_CURRENCY_LIST.STARTED, getCurrencyList);
  yield takeLatest(GET_NATIONALITY_LIST.STARTED, getNationalityList);
  yield takeLatest(GET_CITY_LIST.STARTED, getCityList);
  yield takeLatest(GET_AGENTS_LIST.STARTED, getAgentList);
  yield takeLatest(
    GET_ACTIVE_AGENTS_DETAILS.STARTED,
    getAllActiveAgentsDetailsList,
  );
  yield takeLatest(GET_AGENTS_USERS_LIST.STARTED, getAgentUsersList);
  yield takeLatest(GET_CURRENCIES_BY_AGENTID.STARTED, getCurrenciesByAgentId);
  yield takeLatest(GET_HOTEL_SEARCH.STARTED, getHotelSearch);
  yield takeLatest(GET_HOTELS_LIST.STARTED, getHotelsList);
  yield takeLatest(GET_SEARCH_ADDRESSES.STARTED, getHotelsAddresses);
  yield takeLatest(GET_SEARCH_EXTRA_DETAILS.STARTED, getExtraDetails);
  yield takeLatest(GET_HOTEL_LEVEL_FILTER.STARTED, getHotellevelfilter);
  yield takeLatest(
    GET_ALL_CURRENT_SUPPLIERS.STARTED,
    getGetAllCurrentSuppliers,
  );
  yield takeLatest(
    GET_ACTIVITIES_CURRENT_SUPPLIERS.STARTED,
    getGetActivitiesCurrentSuppliers,
  );
  yield takeLatest(GET_HOTEL_INFO.STARTED, getHotelInfo);
  yield takeLatest(GET_HOTEL_RATES.STARTED, getHotelRates);
  yield takeLatest(GET_ROOM_OPTIONS_RATES.STARTED, getRoomOptionsRates);
  yield takeLatest(
    GET_HOTEL_MULTIROOM_MEAN_RATE.STARTED,
    getHotelMultiroomMeanRate,
  );
  yield takeLatest(GET_AGENT_CREDIT_LIMIT.STARTED, queryAgentCreditLimit);
  yield takeLatest(GET_MAIL_TEMPLATE.STARTED, queryMailTemplate);
  yield takeLatest(
    GET_CURRENCY_CONVERSION_RATES.STARTED,
    queryCurrencyConverter,
  );
  yield takeLatest(
    GET_BOOKINGDRAFT_BY_TWBID.STARTED,
    queryBookingDraftByTWBidAction,
  );
  yield takeLatest(
    GET_GET_THRESHOLDLIMIT.STARTED,
    getthresholdLimitAdminAction,
  );
  yield takeLatest(GET_ADD_MAIL_LOG.STARTED, addMailLog);
  yield takeLatest(
    GET_ADD_UPDATE_BOOKING_UPLOAD.STARTED,
    addUpdateBookingUploadCall,
  );
  yield takeLatest(GET_ADD_UPDATE_BOOKING_DRAFT.STARTED, addUpdateBookingDraft);
  yield takeLatest(
    BOOKINGDETAILS_BY_ITERNARYID.STARTED,
    bokkingdetailsbyiternaryId,
  );
  yield takeLatest(GET_ADD_AGENTQUOTE.STARTED, addAgentQuote);
  yield takeLatest(
    VALIDATE_DUPLICATE_BOOKING.STARTED,
    callValidateDuplicateBooking,
  );
  yield takeLatest(GET_AGENT_BY_ID.STARTED, getAgentById);

  yield takeLatest(GET_AIRPORTS.STARTED, getAirports);
  yield takeLatest(GET_DROP_AIRPORTS.STARTED, getDropAirports);
  yield takeLatest(GET_AIRLINES.STARTED, getAirlines);
  yield takeLatest(GET_ACCOMMODATION.STARTED, getAccommodations);
  yield takeLatest(GET_DROP_ACCOMMODATION.STARTED, getDropAccommodations);
  yield takeLatest(GET_DESTINATION.STARTED, getDestinationDropboxList);
  yield takeLatest(GET_DESTINATIONTO.STARTED, getDestinationToDropboxList);
  yield takeLatest(
    GET_DESTINATION_ACTIVITY.STARTED,
    getDestinationActivityDropboxList,
  );
  yield takeLatest(
    GET_CALL_CANCELLATION_POLICY.STARTED,
    getHotelCancellationPolicy,
  );

  // Booking Process Starts here
  yield takeLatest(GET_BOOKNOW_ID.STARTED, getBooknowId);
  yield takeLatest(GET_RECHECK_PRICE.STARTED, getRecheckPrice);
  // yield takeLatest(GET_BOOKING_DETAILS.STARTED, getBookingDetails);
  yield takeLatest(GET_HOTEL_CHECKOUT_DETAILS.STARTED, getHotelCheckoutDetails);
  // Booking Process Ends here

  yield takeLatest(GET_BOOKING_DETAILS_BYBID.STARTED, getBookingDetailsByBid);
  yield takeLatest(ADD_PG_TRANSACTION_DETAILS.STARTED, addPGTransactionCall);
  yield takeLatest(GENERATE_HASH512_DETAILS.STARTED, generateHash512ActionCall);
  yield takeLatest(GENERATE_FEATURED_HOTELS_DETAILS.STARTED, getFeaturedHotels);
  yield takeLatest(VALIDATE_PAN_DETAILS.STARTED, validatePanCall);
  yield takeLatest(ITINERARY_ID_BY_TEMPID.STARTED, itineraryIdByTempIdCall);
  yield takeLatest(
    ACTIVITY_CANCELLATION_POLICY_DETAILS.STARTED,
    activityCancellationPolicyCall,
  );
  yield takeLatest(
    TRANSFER_CANCELLATION_POLICY_DETAILS.STARTED,
    transferCancellationPolicyCall,
  );
  yield takeLatest(
    UPDATE_VALIDATION_STATUS_DETAILS.STARTED,
    updateValidationStatusCall,
  );
  yield takeLatest(ABANDON_REASONS_DETAILS.STARTED, abandonReasonsCall);
  yield takeLatest(
    GET_ADD_USER_SEARCH_HISTORY.STARTED,
    addUserSearchHistoryCall,
  );
  yield takeLatest(
    GET_GET_USER_SEARCH_HISTORY.STARTED,
    userSearchHistoryFilterCall,
  );
  yield takeLatest(GET_DMC_LIST.STARTED, getDMCList);
  yield takeLatest(GET_DMC_CITIES_LIST.STARTED, getDMCCitiesList);
  yield takeLatest(GET_DMC_TOURTYPES_LIST.STARTED, getDMCTourTypesList);
  yield takeLatest(GET_DMC_PACKAGES_LIST.STARTED, getDMCPackagesList);
  yield takeLatest(
    GET_DMC_PACKAGES_DETAILS_LIST.STARTED,
    getDMCPackDetailsList,
  );
  yield takeLatest(SET_ZOHO_LAYOUT_RULES.STARTED, queryZohoLayoutRules);
  yield takeLatest(
    SET_ZOHO_TICKET_DEPENDENCY_MAPPING.STARTED,
    queryZohoDependencyMapping,
  );
  yield takeLatest(SET_ZOHO_TICKET_CREATION.STARTED, zohoTicketCreation);
  yield takeLatest(BOOKABLE_THRESHOLD_DETAILS.STARTED, getBookableThreshold);
  yield takeLatest(BOOKABLE_CL_DETAILS.STARTED, getBookableCL);
  yield takeLatest(BOOKABLE_WB_DETAILS.STARTED, getBookableWB);
  yield takeLatest(
    GET_AGENT_PROFILE_BY_AGENTID.STARTED,
    agentProfileByAgentIdQuery,
  );
  yield takeLatest(AGENT_ALL_WIDGETS_DATA.STARTED, getAgentAllWidgetsData);
  yield takeLatest(CONFIG_VALUE.STARTED, configValueCall);
  yield takeLatest(PREVIEW_URL.STARTED, previewURLCall);
  yield takeLatest(
    PAYMENT_GATEWAY_TRANSACTIONS.STARTED,
    getPaymentGatewayTransactionsQuery,
  );
  yield takeLatest(POST_PAYMENT_GATEWAY.STARTED, postPaymentGatewayCall);
  yield takeLatest(VALIDATE_PG_CURRENCY.STARTED, validatePGCurrencyCall);
  yield takeLatest(VALIDATE_PAYMENT_LINK.STARTED, validatePaymentLink);
  yield takeLatest(VOUCHER_VIEW_DETAILS.STARTED, voucherViewDetailsCall);
  yield takeLatest(
    VOUCHER_VIEW_EURAIL_DETAILS.STARTED,
    voucherViewEurailTicketDetailsCall,
  );
  yield takeLatest(
    VOUCHER_VIEW_TRANSFER_DETAILS.STARTED,
    VoucherViewTransferDetailsCall,
  );
  yield takeLatest(
    VOUCHER_VIEW_ACTIVITY_DETAILS.STARTED,
    VoucherViewActivityDetailsCall,
  );
  yield takeLatest(BID_FROM_TEMP_ID.STARTED, biDfromTempIdCall);
  yield takeLatest(UPDATE_PG_INVOICE_NUMBER.STARTED, updatePGInvoiceNumberCall);
  // yield takeLatest(ADD_BOOKING_MAIL_DATA.STARTED, addBookingMailDataCall);
  yield takeLatest(GENERATE_LOGINURL_DETAILS.STARTED, getLoginURL);
  yield takeLatest(
    CHECK_PAN_EXISTS_FOR_AGENT_DATA.STARTED,
    checkPanExistForAgentCall,
  );
  yield takeLatest(GRN_INVOICES_ACTIONTYPE.STARTED, BillingInvoiceSaga);
  yield takeLatest(GRN_PROFORMAS_ACTIONTYPE.STARTED, PerformaInvoiceSaga);
  yield takeLatest(AGENT_INVOICE_ACTIONTYPE.STARTED, agentInvoiceSaga);
  yield takeLatest(
    AGENT_INFO_FINALIZE_TRANSFER.STARTED,
    agentInfoFinalizeTransfer,
  );
  yield takeLatest(PRICE_CALCULATE_OC_PC.STARTED, priceCalculateOcPc);
  yield takeLatest(POST_PRICE_CALCULATE.STARTED, postPriceCalculate);
  yield takeLatest(AGENTS_BY_CURRENCY.STARTED, getAgentsByCurrency);
  yield takeLatest(
    AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE.STARTED,
    agentsCurrencyandInvoiceEntitySaga,
  );
  yield takeLatest(BOOKINGS_LIST.STARTED, queryBookingsList);
  yield takeLatest(ADD_TRANSFER_TO_AGENT.STARTED, addTransferToAgentCall);
  yield takeLatest(ADD_FINALIZE_BOOKINGS.STARTED, queryAddFinalizeBookings);
  yield takeLatest(
    ADD_DUPLICATE_BOOKING_MAIL_DATA.STARTED,
    addDuplicateBookingMailDataStart,
  );
  yield takeLatest(
    FINALIZE_BOOKINGS_TRANSFER_ADMIN.STARTED,
    addFinalizeAndTransferForTransferProductAdmin,
  );
  yield takeLatest(
    FINALIZED_BOOKINGS_TRANSFER_AGENT.STARTED,
    addFinalizeAndTransferForTransferProductAgent,
  );
  yield takeLatest(
    ADD_TRANSFER_TO_AGENT_TRANSFER.STARTED,
    addTransferToAgentTransferCall,
  );
  yield takeLatest(
    ACCESS_NOTIFICATIONS.STARTED,
    getAccessNotificationsPermissions,
  );
  yield takeLatest(GET_HOTEL_INVOICE_ACTIONTYPE.STARTED, hotelInvoiceSaga);
  yield takeLatest(GET_EURAIL_INVOICE_ACTIONTYPE.STARTED, eurailInvoiceSaga);
  yield takeLatest(
    GET_ACTIVITY_INVOICE_ACTIONTYPE.STARTED,
    activityInvoiceSaga,
  );
  yield takeLatest(
    GET_TRANSFERS_INVOICE_ACTIONTYPE.STARTED,
    transfersInvoiceSaga,
  );
  yield takeLatest(
    REQUEST_FAILURE_REASON_STATUS.STARTED,
    requestFailureReasonStatusFunc,
  );
  yield takeLatest(
    SEND_VOUCHER_MAIL_ACTION_TYPE.STARTED,
    sendVoucherMailSaga
  );
}

export const sagas = [watcherDashboard];